function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
/*!
 * 
 * @twilio/flex-sdk.js 0.9.1
 * The following license applies to all parts of this software except as documented below.
 * 
 * Copyright (c) 2020 Twilio, Inc.
 * All rights reserved.
 * 
 * Licensed under the Apache License, Version 2.0 (the “License”);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *     http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an “AS IS” BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * 
 */
module.exports = function (e) {
  var t = {};
  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
      return e[t];
    }.bind(null, o));
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 117);
}([function (e, t) {
  e.exports = require("inversify");
}, function (e, t, n) {
  "use strict";

  n.d(t, "g", function () {
    return r.d;
  }), n.d(t, "e", function () {
    return r.b;
  }), n.d(t, "f", function () {
    return r.c;
  }), n.d(t, "c", function () {
    return o.a;
  }), n.d(t, "d", function () {
    return v;
  }), n.d(t, "a", function () {
    return b.a;
  }), n.d(t, "b", function () {
    return h.a;
  });
  var r = n(39),
    o = n(52);
  n(56), n(3), n(57), n(64), n(5), n(50), n(6), n(7), n(9), n(14), n(36);
  function i(e) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function a(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function u(e, t) {
    return !t || "object" !== i(t) && "function" != typeof t ? c(e) : t;
  }
  function c(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function s(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (s = function s(e) {
      if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
      var n;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }
      function r() {
        return l(e, arguments, p(this).constructor);
      }
      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), d(r, e);
    })(e);
  }
  function l(e, t, n) {
    return (l = f() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && d(o, n.prototype), o;
    }).apply(null, arguments);
  }
  function f() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }
  function d(e, t) {
    return (d = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function p(e) {
    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  var v = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && d(e, t);
      }(o, e);
      var t,
        n,
        r = (t = o, n = f(), function () {
          var e,
            r = p(t);
          if (n) {
            var o = p(this).constructor;
            e = Reflect.construct(r, arguments, o);
          } else e = r.apply(this, arguments);
          return u(this, e);
        });
      function o() {
        var e,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Internal Error";
        return a(this, o), e = r.call(this, t), Object.setPrototypeOf(c(e), o.prototype), e;
      }
      return o;
    }(s(Error)),
    b = n(24),
    h = (n(30), n(40), n(66));
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  });
  n(55), n(97), n(65);
  function r(e) {
    var t = e.match("/modules/[A-z]+");
    return t ? t[0].replace("/modules/", "") : "";
  }
  function o(e) {
    var t = e.match("([A-z])+([.]*[A-z]*)[.][jt]s");
    return t ? t[0] : "";
  }
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.to-string.js");
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  var o;
  n.d(t, "a", function () {
    return i;
  }), n.d(t, "b", function () {
    return a.a;
  }), n.d(t, "c", function () {
    return a.c;
  }), n.d(t, "d", function () {
    return u.b;
  }), n.d(t, "e", function () {
    return u.d;
  }), function (e) {
    e.Trace = "trace", e.Debug = "debug", e.Info = "info", e.Warn = "warn", e.Error = "error";
  }(o || (o = {}));
  var i = function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Debug;
      r(this, e), this.loggerName = t, this.severity = n, this.timestamp = new Date(), this.context = {};
    },
    a = n(58),
    u = n(20);
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.iterator.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.iterator.js");
}, function (e, t) {
  e.exports = require("core-js/modules/web.dom-collections.iterator.js");
}, function (e, t, n) {
  "use strict";

  var r = n(21);
  n.d(t, "c", function () {
    return r.c;
  }), n.d(t, "b", function () {
    return r.b;
  }), n.d(t, "e", function () {
    return r.f;
  }), n.d(t, "h", function () {
    return r.j;
  }), n.d(t, "d", function () {
    return r.e;
  }), n.d(t, "f", function () {
    return r.g;
  }), n.d(t, "g", function () {
    return r.h;
  }), n.d(t, "a", function () {
    return r.a;
  });
}, function (e, t) {
  e.exports = require("core-js/modules/es.symbol.js");
}, function (e, t, n) {
  "use strict";

  var r = n(29);
  n.d(t, "b", function () {
    return r.d;
  });
  var o = n(73);
  n.d(t, "a", function () {
    return o.a;
  });
}, function (e, t) {
  e.exports = require("core-js/modules/es.promise.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  }), n.d(t, "d", function () {
    return i;
  }), n.d(t, "c", function () {
    return a;
  }), n.d(t, "f", function () {
    return u;
  }), n.d(t, "e", function () {
    return c;
  }), n.d(t, "g", function () {
    return s;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("TelemetryClient"),
    o = Symbol.for("TelemetryClientFactory"),
    i = Symbol.for("TelemetryEventGroup"),
    a = Symbol.for("TelemetryEventGroupFactory"),
    u = Symbol.for("TelemetryProcessor"),
    c = Symbol.for("TelemetryOptions"),
    s = Symbol.for("TelemetryRateLimiterOptions");
}, function (e, t) {
  e.exports = require("core-js/modules/es.weak-map.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.symbol.description.js");
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), n.d(t, "d", function () {
    return o.d;
  }), n.d(t, "c", function () {
    return o.c;
  }), n.d(t, "b", function () {
    return o.b;
  }), function (e) {
    e.TokenExpired = "tokenExpired", e.TokenAboutToExpire = "tokenAboutToExpire", e.TokenUpdated = "tokenUpdated", e.TokenAutoUpdateFailed = "tokenAutoUpdateFailed", e.TokenMaxLifetimeReached = "tokenMaxLifetimeReached", e.ConnectionLost = "connectionLost", e.ConnectionRestored = "connectionRestored", e.Disconnected = "disconnected";
  }(r || (r = {}));
  var o = n(51);
}, function (e, t, n) {
  "use strict";

  n.d(t, "f", function () {
    return r;
  }), n.d(t, "d", function () {
    return o;
  }), n.d(t, "e", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  }), n.d(t, "b", function () {
    return u;
  }), n.d(t, "c", function () {
    return c;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("TwilsockAdapter"),
    o = Symbol.for("HttpAdapter"),
    i = "TelemetryService",
    a = "ConfigurationService",
    u = "FeaturesService",
    c = "FederatedAuthService";
}, function (e, t) {
  e.exports = require("regenerator-runtime/runtime.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "c", function () {
    return o.b;
  }), n.d(t, "b", function () {
    return o.a;
  }), n.d(t, "a", function () {
    return r;
  });
  var r,
    o = n(49);
  !function (e) {
    e.TokenMaxLifetimeReached = "tokenMaxLifetimeReached", e.TokenAutoUpdateFailed = "tokenAutoUpdateFailed";
  }(r || (r = {}));
}, function (e, t, n) {
  "use strict";

  var r, o, i, a;
  n.d(t, "b", function () {
    return r;
  }), n.d(t, "c", function () {
    return o;
  }), n.d(t, "d", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  }), n.d(t, "e", function () {
    return u.a;
  }), n.d(t, "f", function () {
    return u.b;
  }), function (e) {
    e.Default = "default", e.Error = "error", e.RateLimiter = "rate_limiter";
  }(r || (r = {})), function (e) {
    e.ClientInitialized = "client_initialized", e.ClientDestroyed = "client_destroyed", e.RateLimiterTriggered = "rate_limiter_triggered", e.RateLimiterDisabledFeature = "rate_limiter_disabled_feature";
  }(o || (o = {})), function (e) {
    e.Client = "Client", e.RateLimiter = "RateLimiter";
  }(i || (i = {})), function (e) {
    e.TwilioClient = "twilio_client", e.Twilsock = "twilsock";
  }(a || (a = {}));
  var u = n(47);
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "f", function () {
    return o;
  }), n.d(t, "e", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  }), n.d(t, "d", function () {
    return u;
  }), n.d(t, "c", function () {
    return c;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("loggerFactory"),
    o = Symbol.for("NewableLogger"),
    i = Symbol.for("loglevelFactory"),
    a = Symbol.for("loggerDefaultPlugins"),
    u = Symbol.for("LoggerOptions"),
    c = Symbol.for("LoggerInstances");
}, function (e, t, n) {
  "use strict";

  n.d(t, "f", function () {
    return r;
  }), n.d(t, "c", function () {
    return o;
  }), n.d(t, "e", function () {
    return i;
  }), n.d(t, "b", function () {
    return a;
  }), n.d(t, "d", function () {
    return u;
  }), n.d(t, "j", function () {
    return c;
  }), n.d(t, "i", function () {
    return s;
  }), n.d(t, "g", function () {
    return l;
  }), n.d(t, "h", function () {
    return f;
  }), n.d(t, "a", function () {
    return d;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("EnvironmentConfig"),
    o = Symbol.for("AccountConfig"),
    i = (Symbol.for("AccountConfigData"), Symbol.for("ConfigDataContainer")),
    a = Symbol.for("AccountConfigProvider"),
    u = Symbol.for("AccountConfigUpdater"),
    c = Symbol.for("PublicConfigProvider"),
    s = Symbol.for("PublicConfigMockOptions"),
    l = Symbol.for("FeaturesProvider"),
    f = Symbol.for("getAccountConfig"),
    d = Symbol.for("AccountConfigOptions");
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "f", function () {
    return a;
  }), n.d(t, "e", function () {
    return u;
  }), n.d(t, "c", function () {
    return c;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("Authenticator"),
    o = Symbol.for("AuthenticatorDataContainer"),
    i = Symbol.for("AuthenticatorFactory"),
    a = Symbol.for("TwilioIdpUrl"),
    u = Symbol.for("twilioIdpUrlMockOptions"),
    c = Symbol.for("authenticatorMockOptions");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r.EventEmitter;
  }), n.d(t, "c", function () {
    return o;
  }), n.d(t, "b", function () {
    return i.a;
  });
  var r = n(59);
  n(27);
  function o(e, t, n, r) {
    e.addListener(n, function () {
      for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) n[o] = arguments[o];
      t.emit.apply(t, [r].concat(n));
    });
  }
  var i = n(60);
}, function (e, t, n) {
  "use strict";

  var r, o;
  function i(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  n.d(t, "a", function () {
    return o;
  }), n.d(t, "c", function () {
    return a;
  }), n.d(t, "b", function () {
    return u;
  }), function (e) {
    e[e.PermissionDeniedError = 20003] = "PermissionDeniedError", e[e.InvalidAccessToken = 20101] = "InvalidAccessToken", e[e.AccessTokenExpired = 20104] = "AccessTokenExpired", e[e.TooManyRequests = 20429] = "TooManyRequests", e[e.AuthorizationError = 45003] = "AuthorizationError", e[e.ValidationError = 45004] = "ValidationError", e[e.ConnectionError = 45011] = "ConnectionError", e[e.SDK = 45500] = "SDK", e[e.Unknown = 45501] = "Unknown", e[e.Forbidden = 45502] = "Forbidden", e[e.InvalidParams = 45503] = "InvalidParams", e[e.NotFound = 45504] = "NotFound", e[e.InvalidState = 45505] = "InvalidState", e[e.TooManySDKRequests = 45506] = "TooManySDKRequests", e[e.TemporarilyDisabled = 45507] = "TemporarilyDisabled", e[e.NetworkError = 45508] = "NetworkError", e[e.TwilsockConnectionError = 45511] = "TwilsockConnectionError", e[e.BadRequest = 70002] = "BadRequest", e[e.InvalidCertificate = 70251] = "InvalidCertificate";
  }(o || (o = {}));
  var a = (i(r = {}, o.PermissionDeniedError, "PermissionDeniedError: You lack permission to the resource and method you requested"), i(r, o.InvalidAccessToken, "Invalid Access Token"), i(r, o.AccessTokenExpired, "Access Token expired or expiration date invalid"), i(r, o.TooManyRequests, "TooManyRequests: Twilsock rate limit exceeded"), i(r, o.AuthorizationError, "Attempt to access resource where access is not allowed for given credentials"), i(r, o.ValidationError, "Validation error: request body validation fails"), i(r, o.ConnectionError, "Connection error"), i(r, o.SDK, "Something went wrong, error from inner SDK"), i(r, o.Unknown, "Unknown error"), i(r, o.Forbidden, "User is not authorized to perform the requested operation"), i(r, o.InvalidParams, "Invalid parameters"), i(r, o.NotFound, "Resource not found"), i(r, o.InvalidState, "Invalid state"), i(r, o.TooManySDKRequests, "Too many requests on the Flex SDK API"), i(r, o.TemporarilyDisabled, "The feature has been temporarily disabled"), i(r, o.NetworkError, "NetworkError: Not able to reach the server"), i(r, o.TwilsockConnectionError, "Twilsock connection error"), i(r, o.BadRequest, "BadRequest: The data in the request is unparsable"), i(r, o.InvalidCertificate, "Validation error: invalid certificate"), r),
    u = [o.PermissionDeniedError, o.InvalidAccessToken, o.AccessTokenExpired, o.TooManyRequests, o.AuthorizationError, o.ValidationError, o.BadRequest, o.InvalidCertificate];
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "d", function () {
      return u;
    }), n.d(t, "b", function () {
      return c;
    }), n.d(t, "e", function () {
      return s;
    }), n.d(t, "c", function () {
      return l;
    }), n.d(t, "a", function () {
      return f;
    });
    n(119), n(95), n(96), n(9), n(14), n(3), n(36), n(5), n(6), n(7);
    var o = n(1),
      i = n(2);
    function a(e) {
      return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function u(t, n) {
      if ("object" !== a(t) || null === t || Array.isArray(t)) {
        var u = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, u, "".concat(n, ", expected an object"));
      }
    }
    function c(t, n) {
      if (u(t, n), function (e) {
        try {
          JSON.stringify(e);
        } catch (e) {
          return /^TypeError: Converting circular structure to JSON/.test(e);
        }
        return !1;
      }(t)) {
        var a = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, a, "".concat(n, ", expected an object without cycles"));
      }
    }
    function s(t, n) {
      if ("string" != typeof t) {
        var a = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, a, "".concat(n, ", expected a string"));
      }
    }
    function l(t, n) {
      if (s(t, n), "" === t.trim()) {
        var a = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, a, "".concat(n, ", expected a string which is not empty"));
      }
    }
    function f(t, n) {
      if (!(t in n)) {
        var a = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, a, "".concat(t, " is not a valid key"));
      }
    }
  }).call(this, "src/utils", "src/utils/assert.ts");
}, function (e, t) {
  e.exports = require("core-js/modules/web.dom-collections.for-each.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.concat.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return r;
  }), n.d(t, "c", function () {
    return o;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("RateLimiter"),
    o = Symbol.for("Map<RateLimiter>"),
    i = Symbol.for("Factory<RateLimiter>"),
    a = Symbol.for("cleanupRateLimiters()");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  }), n.d(t, "b", function () {
    return o;
  }), n.d(t, "d", function () {
    return i;
  }), n.d(t, "c", function () {
    return a;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("NewableTwilsockClient"),
    o = Symbol.for("ProductID"),
    i = Symbol.for("Twilsock"),
    a = Symbol.for("TwilsockClientFactory");
}, function (e, t, n) {
  "use strict";

  var r, o;
  function i(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  n.d(t, "a", function () {
    return o;
  }), n.d(t, "b", function () {
    return a;
  }), function (e) {
    e[e.SyncConnectionError = 45510] = "SyncConnectionError", e[e.SyncAccessForbiddenError = 54007] = "SyncAccessForbiddenError", e[e.SyncMapNotFoundError = 54200] = "SyncMapNotFoundError", e[e.SyncMapItemNotFoundError = 54201] = "SyncMapItemNotFoundError", e[e.SyncInvalidMapItemDataError = 54206] = "SyncInvalidMapItemDataError", e[e.SyncInvalidMapItemKeyError = 54209] = "SyncInvalidMapItemKeyError", e[e.SyncNameNotFoundError = 54300] = "SyncNameNotFoundError", e[e.SyncNameAlreadyExistsError = 54301] = "SyncNameAlreadyExistsError", e[e.SyncInvalidNameError = 54302] = "SyncInvalidNameError";
  }(o || (o = {}));
  var a = (i(r = {}, o.SyncConnectionError, "Sync connection error"), i(r, o.SyncAccessForbiddenError, "Sync access forbidden for identity"), i(r, o.SyncMapNotFoundError, "Sync map not found"), i(r, o.SyncInvalidMapItemDataError, "Invalid sync map item data"), i(r, o.SyncInvalidMapItemKeyError, "Invalid sync map item key"), i(r, o.SyncMapItemNotFoundError, "Sync map item not found"), i(r, o.SyncNameNotFoundError, "Sync unique name not found"), i(r, o.SyncNameAlreadyExistsError, "Sync unique name already exists"), i(r, o.SyncInvalidNameError, "Sync invalid unique name"), r);
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.keys.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return o;
  }), n.d(t, "c", function () {
    return r.b;
  }), n.d(t, "b", function () {
    return r.a;
  }), n.d(t, "d", function () {
    return r.d;
  }), n.d(t, "e", function () {
    return r.e;
  });
  n(38);
  var r = n(12);
  function o(e, t) {
    var n = e.get(r.b);
    return n.name = t, n;
  }
}, function (e, t, n) {
  "use strict";

  var r = n(42);
  n.d(t, "b", function () {
    return r.b;
  });
  var o = n(67);
  n.d(t, "a", function () {
    return o.a;
  });
}, function (e, t, n) {
  "use strict";

  var r = n(22);
  n.d(t, "c", function () {
    return r.d;
  }), n.d(t, "b", function () {
    return r.b;
  }), n.d(t, "d", function () {
    return r.f;
  });
  var o = n(75);
  n.d(t, "a", function () {
    return o.a;
  });
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.get-own-property-descriptor.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.symbol.iterator.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });
  var r,
    o = n(99);
  n.d(t, "b", function () {
    return o.TwilsockClient;
  }), function (e) {
    e.TokenExpired = "tokenExpired", e.TokenAboutToExpire = "tokenAboutToExpire", e.StateChanged = "stateChanged", e.ConnectionError = "connectionError", e.Connected = "connected", e.Disconnected = "disconnected";
  }(r || (r = {}));
}, function (e, t) {
  e.exports = require("core-js/modules/es.function.name.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  }), n.d(t, "d", function () {
    return o;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "c", function () {
    return a;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("reThrowErrorWithCustomMessage"),
    o = Symbol.for("throwError"),
    i = Symbol.for("throwErrorFromErrorResponse"),
    a = Symbol.for("throwErrorFromResponse");
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return a;
  }), n.d(t, "e", function () {
    return u;
  }), n.d(t, "c", function () {
    return c;
  }), n.d(t, "a", function () {
    return s;
  }), n.d(t, "b", function () {
    return l;
  });
  n(5), n(50), n(3), n(6), n(7), n(118), n(94), n(53), n(54);
  var r = n(24),
    o = n(30),
    i = new Map([[o.a.SyncConnectionError, r.a.ConnectionError], [o.a.SyncAccessForbiddenError, r.a.Forbidden], [o.a.SyncMapNotFoundError, r.a.NotFound], [o.a.SyncMapItemNotFoundError, r.a.NotFound], [o.a.SyncInvalidMapItemDataError, r.a.InvalidParams], [o.a.SyncInvalidMapItemKeyError, r.a.InvalidParams], [o.a.SyncNameNotFoundError, r.a.NotFound], [o.a.SyncNameAlreadyExistsError, r.a.InvalidState], [o.a.SyncInvalidNameError, r.a.InvalidParams]]);
  function a(e) {
    return !!Object.values(o.a).find(function (t) {
      return t === e;
    });
  }
  function u(e) {
    return function (e) {
      return !!Object.values(r.a).find(function (t) {
        return t === e;
      });
    }(e) || a(e);
  }
  function c(e) {
    return r.b.includes(e);
  }
  function s(e) {
    return function (e) {
      return r.c[e];
    }(e) || function (e) {
      return o.b[e];
    }(e) || "Error";
  }
  function l(e) {
    return i.get(e) || r.a.Unknown;
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });
  n(121), n(55), n(57), n(26), n(122), n(9), n(14), n(3), n(36), n(5), n(6), n(7), n(63), n(38), n(74);
  function r(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null == n) return;
      var r,
        o,
        i = [],
        a = !0,
        u = !1;
      try {
        for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
      } catch (e) {
        u = !0, o = e;
      } finally {
        try {
          a || null == n.return || n.return();
        } finally {
          if (u) throw o;
        }
      }
      return i;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return o(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function i(e) {
    var t = /^\d{4}-\d{1,2}-\d{1,2}/,
      n = new RegExp("date|expiration", "i"),
      o = {};
    return Object.entries(e).forEach(function (i) {
      var a = r(i, 2),
        u = a[0],
        c = a[1];
      (function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      })(e, u) && n.test(u) && t.test(c) ? o[u] = new Date(c) : o[u] = c;
    }), o;
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("localStorage"),
    o = Symbol.for("clearCache");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.filter.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.get-own-property-descriptors.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  }), n.d(t, "b", function () {
    return i;
  });
  var r,
    o = n(1);
  !function (e) {
    e.HostedFlex = "hosted-flex", e.Basic = "basic";
  }(r || (r = {}));
  var i = function i(e, t) {
    if (e === r.Basic) return new Headers({
      Authorization: "Basic ".concat(btoa("token:".concat(t)), ")"),
      "Content-Type": "application/json"
    });
    if (e === r.HostedFlex) return new Headers({
      "x-flex-jwe": t,
      "Content-Type": "application/json"
    });
    throw new o.c(o.a.InvalidParams);
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return vr;
  }), n.d(t, "b", function () {
    return br;
  });
  n(116);
  var r = n(0),
    o = n(22),
    i = (n(17), n(5), n(3), n(6), n(13), n(7), n(11), n(1)),
    a = n(25),
    u = n(4);
  n(55), n(65);
  function c(e) {
    return {
      products: ["flex"],
      resource: (t = e.redirectUrl, t.replace(/((Token|Expiration|Identity|Roles)=[^&]+[&]?)/g, "").replace(/[&?]$/, ""))
    };
    var t;
  }
  var s,
    l,
    f,
    d,
    p = n(16);
  function v(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function b(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          v(i, r, o, a, u, "next", e);
        }
        function u(e) {
          v(i, r, o, a, u, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function h(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function y(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, w(e, t, "get"));
  }
  function m(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, w(e, t, "set"), n), n;
  }
  function w(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var g = Object(r.injectable)()((l = new WeakMap(), f = new WeakMap(), d = new WeakMap(), s = function () {
      function e(t, n, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), l.set(this, {
          writable: !0,
          value: void 0
        }), f.set(this, {
          writable: !0,
          value: void 0
        }), d.set(this, {
          writable: !0,
          value: void 0
        }), m(this, l, t), m(this, f, n(u.b.Auth)), m(this, d, r);
      }
      var t, n, s, v, w, g;
      return e = Object(r.inject)(p.c)(e, void 0, 2) || e, e = Object(r.inject)(u.d)(e, void 0, 1) || e, e = Object(r.inject)(o.a)(e, void 0, 0) || e, t = e, (n = [{
        key: "getIdpUrl",
        value: (g = b(_regeneratorRuntime().mark(function e(t) {
          var n, r, o;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return Object(a.c)(t.redirectUrl, "redirect url"), n = c(t), r = y(this, l).accountSid, e.next = 5, y(this, d).getIdpUrl(r, n);
              case 5:
                if ((o = e.sent).location) {
                  e.next = 9;
                  break;
                }
                throw y(this, f).error("No redirect location from /authenticate request, data: ", o), new i.d("Invalid response from /authenticate endpoint");
              case 9:
                return e.abrupt("return", o.location);
              case 10:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return g.apply(this, arguments);
        })
      }, {
        key: "validateToken",
        value: (w = b(_regeneratorRuntime().mark(function e(t) {
          var n, r;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return n = y(this, l).accountSid, e.next = 3, y(this, d).validateToken(n, {
                  token: t
                }, {
                  token: t
                });
              case 3:
                return r = e.sent, e.abrupt("return", {
                  roles: r.roles,
                  valid: r.valid,
                  dateExpired: r.expiration,
                  identity: r.identity
                });
              case 5:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return w.apply(this, arguments);
        })
      }, {
        key: "refreshToken",
        value: (v = b(_regeneratorRuntime().mark(function e(t) {
          var n, r;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return n = y(this, l).accountSid, e.next = 3, y(this, d).refreshToken(n, {
                  token: t
                });
              case 3:
                return r = e.sent, e.abrupt("return", {
                  token: r.token,
                  dateExpired: r.expiration
                });
              case 5:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return v.apply(this, arguments);
        })
      }]) && h(t.prototype, n), s && h(t, s), e;
    }())) || s,
    j = n(34);
  n(27);
  var k,
    O,
    S = n(8);
  function x(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function E(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, T(e, t, "set"), n), n;
  }
  function T(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var C,
    P,
    R,
    M,
    A,
    I,
    W,
    F,
    D,
    q,
    L,
    N,
    _,
    U,
    V,
    K,
    z = Object(r.injectable)()((O = new WeakMap(), k = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), O.set(this, {
          writable: !0,
          value: void 0
        });
      }
      var t, n, r;
      return t = e, (n = [{
        key: "accountSid",
        get: function get() {
          return function (e, t) {
            return t.get ? t.get.call(e) : t.value;
          }(e = this, T(e, O, "get"));
          var e;
        },
        set: function set(e) {
          E(this, O, e);
        }
      }]) && x(t.prototype, n), r && x(t, r), e;
    }())) || k,
    B = new r.ContainerModule(function (e) {
      e(o.d).to(g), e(o.a).to(z).inSingletonScope(), e(o.b).toFactory(function (e) {
        return function (t) {
          return function (e, t) {
            return e.get(o.a).accountSid = t, e.get(j.c);
          }(e.container, t);
        };
      }), e(o.f).toDynamicValue(function (e) {
        return function (t) {
          return function (e, t) {
            var n = e.get(S.e).twilioServiceLoginUrl;
            return t ? "".concat(n, "?localPort=").concat(t) : n;
          }(e.container, t);
        };
      });
    }),
    H = n(49),
    G = n(18),
    J = n(10),
    $ = n(23);
  function X(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function Y(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          X(i, r, o, a, u, "next", e);
        }
        function u(e) {
          X(i, r, o, a, u, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function Q(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function Z(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, te(e, t, "get"));
  }
  function ee(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, te(e, t, "set"), n), n;
  }
  function te(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var ne,
    re,
    oe,
    ie,
    ae,
    ue,
    ce,
    se,
    le,
    fe,
    de,
    pe,
    ve = Object(r.injectable)()((P = new WeakMap(), R = new WeakMap(), M = new WeakMap(), A = new WeakMap(), I = new WeakMap(), W = new WeakMap(), F = new WeakMap(), D = new WeakMap(), q = new WeakMap(), L = new WeakMap(), N = new WeakMap(), _ = new WeakMap(), U = new WeakMap(), V = new WeakMap(), K = new WeakMap(), C = function () {
      function e(t, n, r, o, a, c) {
        var s,
          l,
          f = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), P.set(this, {
          writable: !0,
          value: void 0
        }), R.set(this, {
          writable: !0,
          value: void 0
        }), M.set(this, {
          writable: !0,
          value: void 0
        }), A.set(this, {
          writable: !0,
          value: void 0
        }), I.set(this, {
          writable: !0,
          value: void 0
        }), W.set(this, {
          writable: !0,
          value: void 0
        }), F.set(this, {
          writable: !0,
          value: void 0
        }), D.set(this, {
          writable: !0,
          value: []
        }), q.set(this, {
          writable: !0,
          value: void 0
        }), L.set(this, {
          writable: !0,
          value: !0
        }), N.set(this, {
          writable: !0,
          value: void 0
        }), _.set(this, {
          writable: !0,
          value: void 0
        }), U.set(this, {
          writable: !0,
          value: void 0
        }), V.set(this, {
          writable: !0,
          value: (s = Y(_regeneratorRuntime().mark(function e() {
            return _regeneratorRuntime().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (!Z(f, P)) {
                    e.next = 5;
                    break;
                  }
                  return e.next = 3, Z(f, K).call(f);
                case 3:
                  e.next = 6;
                  break;
                case 5:
                  ee(f, _, !0);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          })), function () {
            return s.apply(this, arguments);
          })
        }), K.set(this, {
          writable: !0,
          value: (l = Y(_regeneratorRuntime().mark(function e() {
            var t, n, r, o, a;
            return _regeneratorRuntime().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Z(f, N).debug("Auto-updating token"), t = Z(f, P).get().accountSid) {
                    e.next = 4;
                    break;
                  }
                  throw new i.d("Account sid not set");
                case 4:
                  return o = Z(f, R).call(f, t), e.prev = 5, e.next = 8, o.refreshToken(f.token);
                case 8:
                  a = e.sent, (r = a.dateExpired).getTime() === Z(f, A).getTime() && (Z(f, N).warn("Token expiration not extended, because max lifetime reached"), Z(f, U).emit(G.a.TokenMaxLifetimeReached, a.dateExpired)), n = a.token, e.next = 18;
                  break;
                case 14:
                  e.prev = 14, e.t0 = e.catch(5), Z(f, N).error("Failed to refresh token", e.t0), Z(f, U).emit(G.a.TokenAutoUpdateFailed);
                case 18:
                  if (Z(f, L)) {
                    e.next = 21;
                    break;
                  }
                  return Z(f, N).trace("AutoUpdateToken, session destroyed after refreshToken"), e.abrupt("return");
                case 21:
                  if (!n || !r) {
                    e.next = 33;
                    break;
                  }
                  return e.prev = 22, e.next = 25, f.updateToken(n);
                case 25:
                  ee(f, A, r), Z(f, N).info("Token auto-updated"), e.next = 33;
                  break;
                case 29:
                  e.prev = 29, e.t1 = e.catch(22), Z(f, N).error("Failed to auto-update token", e.t1), Z(f, U).emit(G.a.TokenAutoUpdateFailed);
                case 33:
                case "end":
                  return e.stop();
              }
            }, e, null, [[5, 14], [22, 29]]);
          })), function () {
            return l.apply(this, arguments);
          })
        }), ee(this, I, t), ee(this, W, n), ee(this, F, o), ee(this, R, r), ee(this, N, a(u.b.Session)), Z(this, N).debug("Session constructed"), ee(this, U, c);
      }
      var t, n, o, a, c, s;
      return e = Object(r.inject)($.b)(e, void 0, 5) || e, e = Object(r.inject)(u.d)(e, void 0, 4) || e, e = Object(r.inject)(S.b)(e, void 0, 3) || e, e = Object(r.inject)(j.b)(e, void 0, 2) || e, e = Object(r.inject)(G.b)(e, void 0, 1) || e, e = Object(r.inject)(J.b)(e, void 0, 0) || e, t = e, (n = [{
        key: "init",
        value: (s = Y(_regeneratorRuntime().mark(function e(t) {
          var n, r, o;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return Z(this, N).debug("will initialize session with token: ", t), Z(this, N).debug("will update token: ", Z(this, W).autoUpdateToken), ee(this, M, t), e.next = 5, Z(this, I).connect(t);
              case 5:
                return Z(this, W).autoUpdateToken && Z(this, I).addListener(J.a.TokenAboutToExpire, Z(this, V)), e.t0 = ee, e.t1 = this, e.t2 = P, e.next = 11, Z(this, F).call(this, t);
              case 11:
                return e.t3 = e.sent, (0, e.t0)(e.t1, e.t2, e.t3), n = Z(this, P).get().accountSid, r = Z(this, R).call(this, n), e.next = 17, r.validateToken(Z(this, M));
              case 17:
                if (o = e.sent, ee(this, D, o.roles), ee(this, A, o.dateExpired), ee(this, q, o.identity), !Z(this, _)) {
                  e.next = 24;
                  break;
                }
                return e.next = 24, Z(this, K).call(this);
              case 24:
                return e.abrupt("return", Promise.resolve());
              case 25:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return s.apply(this, arguments);
        })
      }, {
        key: "updateToken",
        value: (c = Y(_regeneratorRuntime().mark(function e(t) {
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, Z(this, I).updateToken(t);
              case 2:
                ee(this, M, t), Z(this, N).debug("new token set");
              case 4:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return c.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: (a = Y(_regeneratorRuntime().mark(function e() {
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return ee(this, L, !1), Z(this, I).removeListener(J.a.TokenAboutToExpire, Z(this, V)), e.next = 4, Z(this, I).destroy();
              case 4:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function () {
          return a.apply(this, arguments);
        })
      }, {
        key: "token",
        get: function get() {
          return Z(this, M);
        }
      }, {
        key: "roles",
        get: function get() {
          return Z(this, D);
        }
      }, {
        key: "addListener",
        value: function value(e, t) {
          return Z(this, U).on(e, t), this;
        }
      }, {
        key: "removeListener",
        value: function value(e, t) {
          return Z(this, U).removeListener(e, t), this;
        }
      }]) && Q(t.prototype, n), o && Q(t, o), e;
    }())) || C,
    be = n(76),
    he = new r.ContainerModule(function (e) {
      e(H.b).to(ve).inSingletonScope(), e(H.a).toConstantValue(Object(be.a)());
    }),
    ye = n(15),
    me = (n(26), n(31), n(72), n(63), n(9), n(14), n(36), n(74), n(38), n(35), n(32)),
    we = n(19),
    ge = n(70);
  function je(e) {
    return function (e) {
      if (Array.isArray(e)) return ke(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return ke(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ke(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function ke(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Oe(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function Se(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          Oe(i, r, o, a, u, "next", e);
        }
        function u(e) {
          Oe(i, r, o, a, u, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function xe(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function Ee(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, Ce(e, t, "get"));
  }
  function Te(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, Ce(e, t, "set"), n), n;
  }
  function Ce(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var Pe,
    Re,
    Me,
    Ae,
    Ie,
    We,
    Fe = (ne = Object(r.injectable)(), re = Object(r.postConstruct)(), ne((ae = new WeakMap(), ue = new WeakMap(), ce = new WeakMap(), se = new WeakMap(), le = new WeakMap(), fe = new WeakMap(), de = new WeakMap(), pe = new WeakMap(), Pe = (ie = function () {
      function e(t, n, r, o, i, a, c, s, l) {
        var f,
          d = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), ae.set(this, {
          writable: !0,
          value: void 0
        }), ue.set(this, {
          writable: !0,
          value: void 0
        }), ce.set(this, {
          writable: !0,
          value: void 0
        }), se.set(this, {
          writable: !0,
          value: void 0
        }), le.set(this, {
          writable: !0,
          value: void 0
        }), fe.set(this, {
          writable: !0,
          value: void 0
        }), de.set(this, {
          writable: !0,
          value: void 0
        }), pe.set(this, {
          writable: !0,
          value: (f = Se(_regeneratorRuntime().mark(function e() {
            var t, n;
            return _regeneratorRuntime().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, t = Ee(d, le), n = t.createEventGroup(we.b.Default), e.next = 5, n.addEvents({
                    eventName: we.c.ClientDestroyed,
                    eventSource: we.d.Client
                  });
                case 5:
                  e.next = 10;
                  break;
                case 7:
                  e.prev = 7, e.t0 = e.catch(0), Ee(d, ce).error("Failed to send telemetry destroy event", e.t0);
                case 10:
                case "end":
                  return e.stop();
              }
            }, e, null, [[0, 7]]);
          })), function () {
            return f.apply(this, arguments);
          })
        }), Te(this, ae, t), Te(this, ue, n), this.config = {
          account: r,
          fetchFeatures: l
        }, Te(this, se, o), Te(this, le, i), Te(this, ce, a(u.b.Client)), Te(this, fe, c), Te(this, de, s);
      }
      var t, n, o, i, a;
      return e = Object(r.inject)(S.f)(e, void 0, 8) || e, e = Object(r.inject)(ge.a)(e, void 0, 7) || e, e = Object(r.inject)($.b)(e, void 0, 6) || e, e = Object(r.inject)(u.d)(e, void 0, 5) || e, e = Object(r.inject)(we.e)(e, void 0, 4) || e, e = Object(r.inject)(me.b)(e, void 0, 3) || e, e = Object(r.inject)(S.c)(e, void 0, 2) || e, e = Object(r.inject)(J.b)(e, void 0, 1) || e, e = Object(r.inject)(G.c)(e, void 0, 0) || e, t = e, (n = [{
        key: "setupProxies",
        value: function value() {
          Object($.c)(Ee(this, ue), Ee(this, fe), J.a.TokenAboutToExpire, ye.a.TokenAboutToExpire), Object($.c)(Ee(this, ue), Ee(this, fe), J.a.TokenExpired, ye.a.TokenExpired), Object($.c)(Ee(this, ue), Ee(this, fe), J.a.TokenUpdated, ye.a.TokenUpdated), Object($.c)(Ee(this, ue), Ee(this, fe), J.a.ConnectionError, ye.a.ConnectionLost), Object($.c)(Ee(this, ue), Ee(this, fe), J.a.Connected, ye.a.ConnectionRestored), Object($.c)(Ee(this, ue), Ee(this, fe), J.a.Disconnected, ye.a.Disconnected), Object($.c)(Ee(this, ae), Ee(this, fe), G.a.TokenAutoUpdateFailed, ye.a.TokenAutoUpdateFailed), Object($.c)(Ee(this, ae), Ee(this, fe), G.a.TokenMaxLifetimeReached, ye.a.TokenMaxLifetimeReached);
        }
      }, {
        key: "updateToken",
        value: (a = Se(_regeneratorRuntime().mark(function e(t) {
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, Ee(this, ae).updateToken(t);
              case 2:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return a.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: (i = Se(_regeneratorRuntime().mark(function e() {
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, Ee(this, pe).call(this);
              case 2:
                return Ee(this, ce).debug("client log out"), e.next = 5, Ee(this, ae).destroy();
              case 5:
                Ee(this, fe).removeAllListeners(), Ee(this, de).call(this);
              case 7:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function () {
          return i.apply(this, arguments);
        })
      }, {
        key: "roles",
        get: function get() {
          return je(Ee(this, ae).roles);
        }
      }, {
        key: "token",
        get: function get() {
          return Ee(this, ae).token;
        }
      }, {
        key: "createTelemetryClient",
        value: function value(e) {
          return Ee(this, se).call(this, e);
        }
      }, {
        key: "addListener",
        value: function value(e, t) {
          return Ee(this, fe).on(e, t), this;
        }
      }, {
        key: "removeListener",
        value: function value(e, t) {
          return Ee(this, fe).removeListener(e, t), this;
        }
      }]) && xe(t.prototype, n), o && xe(t, o), e;
    }()).prototype, Re = "setupProxies", Me = [re], Ae = Object.getOwnPropertyDescriptor(ie.prototype, "setupProxies"), Ie = ie.prototype, We = {}, Object.keys(Ae).forEach(function (e) {
      We[e] = Ae[e];
    }), We.enumerable = !!We.enumerable, We.configurable = !!We.configurable, ("value" in We || We.initializer) && (We.writable = !0), We = Me.slice().reverse().reduce(function (e, t) {
      return t(Pe, Re, e) || e;
    }, We), Ie && void 0 !== We.initializer && (We.value = We.initializer ? We.initializer.call(Ie) : void 0, We.initializer = void 0), void 0 === We.initializer && (Object.defineProperty(Pe, Re, We), We = null), oe = ie)) || oe),
    De = n(77),
    qe = n(78),
    Le = new r.ContainerModule(function (e) {
      e(ye.b).to(qe.a).inSingletonScope(), e(ye.d).to(Fe).inSingletonScope(), e(ye.c).toProvider(function (e) {
        return function (t, n) {
          return Object(De.a)(e.container, t, n);
        };
      });
    }),
    Ne = n(39),
    _e = n(24),
    Ue = n(40),
    Ve = n(52);
  function Ke(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function ze(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          Ke(i, r, o, a, u, "next", e);
        }
        function u(e) {
          Ke(i, r, o, a, u, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function Be() {
    return (Be = ze(_regeneratorRuntime().mark(function e(t, n) {
      var r, o, i, a, c;
      return _regeneratorRuntime().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.prev = 0, o = t.get(we.f), i = n.wrappedError, a = Object(Ue.c)(n.code), e.next = 6, o.addErrorEvent({
              eventName: "error_reported",
              error: {
                code: n.code,
                debugger: a,
                message: n.message,
                module: n.metadata.module,
                reporter: "flex-sdk",
                resourceSid: n.metadata.resourceSid,
                severity: n.metadata.severity,
                source: n.metadata.source || "flex-sdk",
                stackTrace: n.stack,
                unhandled: n.metadata.unhandled,
                wrappedErrorCode: null == i ? void 0 : i.code,
                wrappedErrorMessage: null !== (r = null == i ? void 0 : i.message) && void 0 !== r ? r : void 0
              }
            });
          case 6:
            e.next = 13;
            break;
          case 8:
            e.prev = 8, e.t0 = e.catch(0), c = t.get(u.d), c(u.b.Error).debug("Failed to report the error", e.t0);
          case 13:
          case "end":
            return e.stop();
        }
      }, e, null, [[0, 8]]);
    }))).apply(this, arguments);
  }
  function He(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function Ge(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          He(i, r, o, a, u, "next", e);
        }
        function u(e) {
          He(i, r, o, a, u, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function Je(e, t, n, r, o) {
    if (o instanceof Ve.a) throw o;
    t && Object(Ue.e)(t) || console.warn("Unknown error code");
    var i = t;
    Object(Ue.d)(t) && (i = Object(Ue.b)(t));
    var a = new Ve.a(i, n, r, o);
    throw function (e, t) {
      Be.apply(this, arguments);
    }(e, a), a;
  }
  function $e(e, t) {
    throw new Ve.a(e.code, e.metadata, t, e.wrappedError);
  }
  function Xe(e, t, n) {
    if (t instanceof Ve.a) throw t;
    Je(e, t.code ? t.code : _e.a.Unknown, n, t.message);
  }
  function Ye() {
    return (Ye = Ge(_regeneratorRuntime().mark(function e(t, n, r, o) {
      var i;
      return _regeneratorRuntime().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, n.json();
          case 2:
            (i = e.sent).message = o || i.message, Xe(t, i, r);
          case 5:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  var Qe = new r.ContainerModule(function (e) {
      e(Ne.d).toDynamicValue(function (e) {
        return function (t, n, r, o) {
          return Je(e.container, t, n, r, o);
        };
      }).inSingletonScope(), e(Ne.b).toDynamicValue(function (e) {
        return function (t, n) {
          return Xe(e.container, t, n);
        };
      }).inSingletonScope(), e(Ne.c).toDynamicValue(function (e) {
        return function (t, n, r) {
          return function (e, t, n, r) {
            return Ye.apply(this, arguments);
          }(e.container, t, n, r);
        };
      }).inSingletonScope(), e(Ne.a).toConstantValue($e);
    }),
    Ze = n(59),
    et = n(60),
    tt = new r.ContainerModule(function (e) {
      e(et.a).toDynamicValue(function () {
        return new Ze.EventEmitter();
      });
    }),
    nt = n(102),
    rt = n(21);
  n(43), n(44);
  function ot(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function it(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var at,
    ut,
    ct,
    st,
    lt = function lt() {
      var e;
      return function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ot(Object(n), !0).forEach(function (t) {
            it(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ot(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }({
        twilioServiceLoginUrl: "https://flex.twilio.com/admin"
      }, null === (e = window.__TWILIO_FLEX_SDK__) || void 0 === e ? void 0 : e.environmentConfig);
    },
    ft = (n(98), ["accountSid"]);
  function dt(e, t) {
    if (null == e) return {};
    var n,
      r,
      o = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          o = {},
          i = Object.keys(e);
        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o;
      }(e, t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }
  function pt(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function vt(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function bt(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, yt(e, t, "get"));
  }
  function ht(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, yt(e, t, "set"), n), n;
  }
  function yt(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var mt = Object(r.injectable)()((ut = new WeakMap(), ct = new WeakMap(), st = new WeakMap(), at = function () {
      function e(t, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), ut.set(this, {
          writable: !0,
          value: void 0
        }), ct.set(this, {
          writable: !0,
          value: void 0
        }), st.set(this, {
          writable: !0,
          value: void 0
        }), ht(this, ut, t), ht(this, ct, n);
      }
      var t, n, o, i, u;
      return e = Object(r.inject)(rt.d)(e, void 0, 1) || e, e = Object(r.inject)(rt.e)(e, void 0, 0) || e, t = e, (n = [{
        key: "get",
        value: function value() {
          return bt(this, ut).get();
        }
      }, {
        key: "set",
        value: (i = _regeneratorRuntime().mark(function e(t) {
          var n,
            r,
            o,
            i,
            u,
            c = this;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return n = bt(this, ut).get(), r = n.accountSid, o = dt(n, ft), Object.keys(t).map(function (e) {
                  return Object(a.a)(e, o);
                }), i = function i() {
                  return bt(c, ct).call(c, r, t);
                }, e.next = 6, this.updateInCallOrder(i);
              case 6:
                return u = e.sent, bt(this, ut).set(u), e.abrupt("return", Promise.resolve());
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        }), u = function u() {
          var e = this,
            t = arguments;
          return new Promise(function (n, r) {
            var o = i.apply(e, t);
            function a(e) {
              pt(o, n, r, a, u, "next", e);
            }
            function u(e) {
              pt(o, n, r, a, u, "throw", e);
            }
            a(void 0);
          });
        }, function (e) {
          return u.apply(this, arguments);
        })
      }, {
        key: "updateInCallOrder",
        value: function value(e) {
          return bt(this, st) ? ht(this, st, bt(this, st).then(function () {
            return e();
          })) : ht(this, st, e()), bt(this, st);
        }
      }]) && vt(t.prototype, n), o && vt(t, o), e;
    }())) || at,
    wt = n(103);
  function gt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function jt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? gt(Object(n), !0).forEach(function (t) {
        kt(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gt(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function kt(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Ot(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  var St = function () {
      var e,
        t = (e = _regeneratorRuntime().mark(function e(t, n, r) {
          var o, i;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return o = t.get(p.a), e.next = 3, o.updateConfiguration(jt({
                  accountSid: n
                }, r));
              case 3:
                return i = e.sent, e.abrupt("return", i);
              case 5:
              case "end":
                return e.stop();
            }
          }, e);
        }), function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function a(e) {
              Ot(i, r, o, a, u, "next", e);
            }
            function u(e) {
              Ot(i, r, o, a, u, "throw", e);
            }
            a(void 0);
          });
        });
      return function (e, n, r) {
        return t.apply(this, arguments);
      };
    }(),
    xt = n(79),
    Et = n(106),
    Tt = n(80);
  var Ct = new r.ContainerModule(function (e) {
      e(S.c).to(mt).inSingletonScope(), e(S.d).to(xt.a).inSingletonScope(), e(S.b).toProvider(function (e) {
        return Object(nt.a)(e.container);
      }), e(rt.d).toDynamicValue(function (e) {
        return function (t, n) {
          return St(e.container, t, n);
        };
      }), e(S.e).toDynamicValue(lt), e(S.h).toProvider(function (e) {
        return function (t) {
          return Object(wt.a)(e.container, t);
        };
      }), e(S.f).toProvider(Et.a), e(S.g).toDynamicValue(function (e) {
        return Object(Tt.a)(e.container);
      }), e(S.a).toConstantValue({
        query: {
          UiVersion: void 0
        }
      });
    }),
    Pt = n(29),
    Rt = n(37),
    Mt = n(107);
  var At,
    It,
    Wt = new r.ContainerModule(function (e) {
      e(Pt.a).toConstructor(Rt.b), e(Pt.b).toConstantValue("flex"), e(Pt.d).to(Mt.a).inSingletonScope(), e(Pt.c).toFactory(function (e) {
        return function (t, n, r) {
          return function (e, t, n, r) {
            return new (e.get(Pt.a))(t, n, r);
          }(e.container, t, n, r);
        };
      });
    }),
    Ft = n(108),
    Dt = Symbol.for("Rbac"),
    qt = (n(53), n(54), new r.ContainerModule(function (e) {
      e(Dt).toDynamicValue(function (e) {
        return {
          requiredRole: Object(Ft.a)(e.container),
          hasRole: (t = e.container, function (e) {
            return t.get(G.c).roles.includes(e);
          })
        };
        var t;
      });
    })),
    Lt = (n(50), n(61)),
    Nt = n(20),
    _t = n(81),
    Ut = n(82);
  function Vt(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Kt(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, Bt(e, t, "get"));
  }
  function zt(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, Bt(e, t, "set"), n), n;
  }
  function Bt(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var Ht,
    Gt,
    Jt,
    $t = Object(r.injectable)()((It = new WeakMap(), At = function e(t) {
      var n = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), It.set(this, {
        writable: !0,
        value: void 0
      }), Vt(this, "trace", function () {
        var e;
        (e = Kt(n, It)).trace.apply(e, arguments);
      }), Vt(this, "debug", function () {
        var e;
        (e = Kt(n, It)).debug.apply(e, arguments);
      }), Vt(this, "log", function () {
        var e;
        (e = Kt(n, It)).debug.apply(e, arguments);
      }), Vt(this, "info", function () {
        var e;
        (e = Kt(n, It)).info.apply(e, arguments);
      }), Vt(this, "warn", function () {
        var e;
        (e = Kt(n, It)).warn.apply(e, arguments);
      }), Vt(this, "error", function () {
        var e;
        (e = Kt(n, It)).error.apply(e, arguments);
      }), Vt(this, "setLevel", function (e) {
        Kt(n, It).setLevel(e);
      }), Vt(this, "getLevel", function () {
        return Kt(n, It).getLevel();
      }), zt(this, It, t);
    })) || At,
    Xt = function Xt(e) {
      return e < 10 ? "0".concat(e) : "".concat(e);
    },
    Yt = function Yt(e) {
      var t = e.getFullYear(),
        n = Xt(e.getMonth() + 1),
        r = Xt(e.getDate()),
        o = Xt(e.getHours()),
        i = Xt(e.getMinutes()),
        a = Xt(e.getSeconds()),
        u = Xt(e.getMilliseconds());
      return "".concat(t, "-").concat(n, "-").concat(r, " ").concat(o, ":").concat(i, ":").concat(a, ".").concat(u);
    },
    Qt = [function (e) {
      return function (t, n, r) {
        return function (o) {
          for (var i = o instanceof u.a, a = arguments.length, c = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++) c[s - 1] = arguments[s];
          i || c.unshift(o);
          var l = i ? o : new u.a(r, t),
            f = e(t, n, r);
          return f.apply(void 0, [l].concat(c));
        };
      };
    }, function (e) {
      return function (t, n, r) {
        return function (o) {
          for (var i = e(t, n, r), a = arguments.length, u = new Array(a > 1 ? a - 1 : 0), c = 1; c < a; c++) u[c - 1] = arguments[c];
          return i.apply(void 0, [o].concat(u));
        };
      };
    }, function (e) {
      return function (t, n, r) {
        return function (o) {
          for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), u = 1; u < i; u++) a[u - 1] = arguments[u];
          o.data || (o.data = a);
          var c = e(t, n, r);
          return c.apply(void 0, [o].concat(a));
        };
      };
    }, function (e) {
      return function (t, n, r) {
        return function (o) {
          for (var i = Yt(o.timestamp), a = o.severity.toUpperCase(), u = "[".concat(i, "] Flex SDK → ").concat(r, " (").concat(a, "): "), c = e(t, n, r), s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), f = 1; f < s; f++) l[f - 1] = arguments[f];
          return c.apply(void 0, [u].concat(l));
        };
      };
    }].reverse(),
    Zt = function Zt(e) {
      return Qt.forEach(function (t) {
        var n = e.methodFactory;
        e.methodFactory = t(n);
      }), e.setLevel(e.getLevel()), e;
    },
    en = new r.ContainerModule(function (e) {
      e(Nt.e).toConstantValue(Lt.getLogger), e(Nt.b).toFactory(function (e) {
        return Object(_t.a)(e.container);
      }), e(Nt.f).toConstructor($t), e(Nt.a).toConstantValue([Zt]), e(Nt.d).toConstantValue(Object(Ut.a)()), e(Nt.c).toConstantValue(new Map());
    }),
    tn = n(12);
  function nn(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function rn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function on(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, un(e, t, "get"));
  }
  function an(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, un(e, t, "set"), n), n;
  }
  function un(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var cn,
    sn,
    ln,
    fn,
    dn = Object(r.injectable)()((Gt = new WeakMap(), Jt = new WeakMap(), Ht = function () {
      function e(t, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Gt.set(this, {
          writable: !0,
          value: void 0
        }), Jt.set(this, {
          writable: !0,
          value: void 0
        }), an(this, Gt, t), an(this, Jt, n(u.c.TelemetryClient));
      }
      var t, n, o, i, a;
      return e = Object(r.inject)(u.d)(e, void 0, 1) || e, e = Object(r.inject)(tn.c)(e, void 0, 0) || e, t = e, (n = [{
        key: "createEventGroup",
        value: function value(e) {
          return on(this, Jt).debug("creating event group with name: ", e), on(this, Gt).call(this, this, e);
        }
      }, {
        key: "setSessionData",
        value: (i = _regeneratorRuntime().mark(function e(t) {
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                this.sessionData = t;
              case 1:
              case "end":
                return e.stop();
            }
          }, e, this);
        }), a = function a() {
          var e = this,
            t = arguments;
          return new Promise(function (n, r) {
            var o = i.apply(e, t);
            function a(e) {
              nn(o, n, r, a, u, "next", e);
            }
            function u(e) {
              nn(o, n, r, a, u, "throw", e);
            }
            a(void 0);
          });
        }, function (e) {
          return a.apply(this, arguments);
        })
      }]) && rn(t.prototype, n), o && rn(t, o), e;
    }())) || Ht;
  function pn(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function vn(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          pn(i, r, o, a, u, "next", e);
        }
        function u(e) {
          pn(i, r, o, a, u, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function bn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function hn(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, mn(e, t, "get"));
  }
  function yn(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, mn(e, t, "set"), n), n;
  }
  function mn(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var wn,
    gn,
    jn,
    kn,
    On,
    Sn,
    xn,
    En,
    Tn,
    Cn,
    Pn,
    Rn,
    Mn,
    An,
    In = Object(r.injectable)()((sn = new WeakMap(), ln = new WeakMap(), fn = new WeakMap(), cn = function () {
      function e(t, n, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), sn.set(this, {
          writable: !0,
          value: void 0
        }), ln.set(this, {
          writable: !0,
          value: void 0
        }), fn.set(this, {
          writable: !0,
          value: void 0
        }), yn(this, sn, t), yn(this, ln, n), yn(this, fn, r);
      }
      var t, n, o, i, a;
      return e = Object(r.inject)(J.b)(e, void 0, 2) || e, e = Object(r.inject)(tn.e)(e, void 0, 1) || e, e = Object(r.inject)(tn.f)(e, void 0, 0) || e, t = e, (n = [{
        key: "addEvents",
        value: (a = vn(_regeneratorRuntime().mark(function e() {
          var t,
            n,
            r,
            o,
            i = arguments;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                for (n = i.length, r = new Array(n), o = 0; o < n; o++) r[o] = i[o];
                return e.abrupt("return", (t = hn(this, sn)).processEvents.apply(t, [this.telemetryClient.name, this.name, this.telemetryClient.sessionData].concat(r)));
              case 2:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function () {
          return a.apply(this, arguments);
        })
      }, {
        key: "addErrorEvent",
        value: (i = vn(_regeneratorRuntime().mark(function e(t) {
          var n;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n = hn(this, fn).isConnected(), hn(this, ln).reportErrors && n) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return", {
                  eventsSucceeded: 0,
                  eventsFailed: 0,
                  eventsNotProcessed: 1
                });
              case 4:
                return e.abrupt("return", hn(this, sn).processEvents("flex-ui-sdk-error-v1", this.name, this.telemetryClient.sessionData, t));
              case 5:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return i.apply(this, arguments);
        })
      }]) && bn(t.prototype, n), o && bn(t, o), e;
    }())) || cn,
    Wn = n(110),
    Fn = n(83),
    Dn = {
      timeWindow: 6e4,
      maxHitsInTimeWindow: 100,
      disableFeatureThreshold: 5
    },
    qn = new r.ContainerModule(function (e) {
      e(tn.a).toFactory(function (e) {
        return function (t) {
          return Object(me.a)(e.container, t);
        };
      }), e(tn.b).to(dn), e(tn.c).toFactory(function (e) {
        return function (t, n) {
          return function (e, t, n) {
            var r = e.get(tn.d);
            return r.name = n, r.telemetryClient = t, r;
          }(e.container, t, n);
        };
      }), e(tn.d).to(In), e(tn.f).to(Wn.a).inSingletonScope(), e(tn.e).toConstantValue(Object(Fn.a)()), e(tn.g).toConstantValue(Dn);
    }),
    Ln = n(47),
    Nn = new r.ContainerModule(function (e) {
      e(Ln.a).toDynamicValue(function (e) {
        return Object(me.a)(e.container, "sdk-v1");
      }).inSingletonScope(), e(Ln.b).toDynamicValue(function (e) {
        return e.container.get(Ln.a).createEventGroup();
      }).inSingletonScope();
    }),
    _n = n(84),
    Un = n(85);
  n(95);
  function Vn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function Kn(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, Bn(e, t, "get"));
  }
  function zn(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, Bn(e, t, "set"), n), n;
  }
  function Bn(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var Hn,
    Gn,
    Jn = {
      rateLimiterErrorCode: i.a.TooManySDKRequests,
      disableFeatureErrorCode: i.a.TemporarilyDisabled,
      disableFeatureThreshold: Number.MAX_VALUE
    },
    $n = Object(r.injectable)()((gn = new WeakMap(), jn = new WeakMap(), kn = new WeakMap(), On = new WeakMap(), Sn = new WeakMap(), xn = new WeakMap(), En = new WeakMap(), Tn = new WeakMap(), Cn = new WeakMap(), Pn = new WeakMap(), Rn = new WeakMap(), Mn = new WeakMap(), An = new WeakMap(), wn = function () {
      function e(t, n) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), gn.set(this, {
          writable: !0,
          value: void 0
        }), jn.set(this, {
          writable: !0,
          value: 0
        }), kn.set(this, {
          writable: !0,
          value: 0
        }), On.set(this, {
          writable: !0,
          value: void 0
        }), Sn.set(this, {
          writable: !0,
          value: void 0
        }), xn.set(this, {
          writable: !0,
          value: void 0
        }), En.set(this, {
          writable: !0,
          value: function value() {
            zn(r, jn, 0), Kn(r, xn).trace('rate limiter window reset. name="'.concat(r.name, '"'));
          }
        }), Tn.set(this, {
          writable: !0,
          value: function value() {
            zn(r, jn, Kn(r, jn) + 1);
          }
        }), Cn.set(this, {
          writable: !0,
          value: function value() {
            Kn(r, jn) - 1 === Kn(r, gn).maxHitsInTimeWindow && zn(r, kn, Kn(r, kn) + 1);
          }
        }), Pn.set(this, {
          writable: !0,
          value: function value() {
            if (Kn(r, kn) >= Kn(r, gn).disableFeatureThreshold) throw Kn(r, xn).warn('temporarily disabled. name="'.concat(r.name, '", hitCount=').concat(Kn(r, jn), ", windowCount=").concat(Kn(r, kn))), new i.c(i.a.TemporarilyDisabled, void 0, "Feature disabled by rate limiter ".concat(r.name));
            if (r.hitCountInTimeWindow > r.maxHitsInTimeWindow) throw Kn(r, xn).warn('rate limiter hit. name="'.concat(r.name, '", hitCount=').concat(Kn(r, jn))), new i.c(i.a.TooManySDKRequests, void 0, "Request blocked by rate limiter ".concat(r.name));
          }
        }), Rn.set(this, {
          writable: !0,
          value: function value() {
            Kn(r, jn) - 1 === Kn(r, gn).maxHitsInTimeWindow && (Kn(r, kn) === Kn(r, gn).disableFeatureThreshold ? Kn(r, An).call(r) : Kn(r, kn) < Kn(r, gn).disableFeatureThreshold && Kn(r, Mn).call(r));
          }
        }), Mn.set(this, {
          writable: !0,
          value: function value() {
            Kn(r, Sn).addEvents({
              eventName: we.c.RateLimiterTriggered,
              eventSource: we.d.RateLimiter,
              resource: {
                id: Kn(r, gn).name
              }
            });
          }
        }), An.set(this, {
          writable: !0,
          value: function value() {
            Kn(r, Sn).addEvents({
              eventName: we.c.RateLimiterDisabledFeature,
              eventSource: we.d.RateLimiter,
              resource: {
                id: Kn(r, gn).name
              }
            });
          }
        }), zn(this, Sn, t.createEventGroup(we.b.RateLimiter)), zn(this, xn, n(u.b.RateLimiter));
      }
      var t, n, o;
      return e = Object(r.inject)(u.d)(e, void 0, 1) || e, e = Object(r.inject)(we.e)(e, void 0, 0) || e, t = e, (n = [{
        key: "setup",
        value: function value(e) {
          if (Kn(this, gn)) throw new i.d("RateLimiter is already initialized");
          if (e.timeWindow < 100) throw new i.d("timeWindow should be >= 100");
          zn(this, gn, {
            maxHitsInTimeWindow: e.maxHitsInTimeWindow,
            disableFeatureThreshold: e.disableFeatureThreshold || Jn.disableFeatureThreshold,
            timeWindow: e.timeWindow,
            rateLimiterErrorCode: e.rateLimiterErrorCode || Jn.rateLimiterErrorCode,
            disableFeatureErrorCode: e.disableFeatureErrorCode || Jn.disableFeatureErrorCode,
            name: e.name
          }), zn(this, On, setInterval(Kn(this, En), this.timeWindow));
        }
      }, {
        key: "maxHitsInTimeWindow",
        get: function get() {
          return Kn(this, gn).maxHitsInTimeWindow;
        }
      }, {
        key: "hitCountInTimeWindow",
        get: function get() {
          return Kn(this, jn);
        }
      }, {
        key: "name",
        get: function get() {
          return Kn(this, gn).name;
        }
      }, {
        key: "timeWindow",
        get: function get() {
          return Kn(this, gn).timeWindow;
        }
      }, {
        key: "check",
        value: function value() {
          if (!Kn(this, gn)) throw new i.d("Rate limiter not set up, call setup()");
          Kn(this, Tn).call(this), Kn(this, Cn).call(this), Kn(this, Rn).call(this), Kn(this, Pn).call(this);
        }
      }, {
        key: "cleanup",
        value: function value() {
          clearInterval(Kn(this, On));
        }
      }]) && Vn(t.prototype, n), o && Vn(t, o), e;
    }())) || wn,
    Xn = n(28),
    Yn = new r.ContainerModule(function (e) {
      e(Xn.d).to($n), e(Xn.c).toConstantValue(new Map()), e(Xn.b).toFactory(function (e) {
        return function (t) {
          return Object(Un.a)(e.container, t);
        };
      }), e(Xn.a).toDynamicValue(function (e) {
        return function () {
          return Object(_n.a)(e.container);
        };
      });
    }),
    Qn = (n(94), n(67)),
    Zn = function Zn(e) {
      var t = e.container;
      return function () {
        t.get(u.d)(u.b.Storage).debug("Clearing out Flex SDK local storage cache"), Object.values(Qn.a).forEach(function (e) {
          localStorage.removeItem(e);
        });
      };
    };
  function er(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function tr(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, rr(e, t, "get"));
  }
  function nr(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, rr(e, t, "set"), n), n;
  }
  function rr(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var or,
    ir = Object(r.injectable)()((Gn = new WeakMap(), Hn = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Gn.set(this, {
          writable: !0,
          value: void 0
        }), nr(this, Gn, t(u.b.Storage));
      }
      var t, n, o;
      return e = Object(r.inject)(u.d)(e, void 0, 0) || e, t = e, (n = [{
        key: "getCachedItem",
        value: function value(e) {
          var t = localStorage.getItem(e);
          if (t) {
            var n = JSON.parse(t);
            return new Date().getTime() > n.expiry ? (localStorage.removeItem(e), void tr(this, Gn).debug("The ".concat(e, " cache item has expired"))) : n.value;
          }
          tr(this, Gn).debug("The ".concat(e, " cache item is not available"));
        }
      }, {
        key: "setCachedItem",
        value: function value(e, t) {
          var n = {
            value: t,
            expiry: new Date().getTime() + 864e5
          };
          try {
            localStorage.setItem(e, JSON.stringify(n));
          } catch (e) {
            tr(this, Gn).error(e);
          }
          tr(this, Gn).debug("Cached ".concat(e));
        }
      }]) && er(t.prototype, n), o && er(t, o), e;
    }())) || Hn,
    ar = n(42),
    ur = new r.ContainerModule(function (e) {
      e(ar.b).to(ir).inSingletonScope(), e(ar.a).toDynamicValue(Zn);
    }),
    cr = n(86),
    sr = n(87),
    lr = n(91),
    fr = n(88),
    dr = n(89),
    pr = n(90);
  function vr() {
    var e = new r.Container();
    return e.load(B), e.load(Ct), e.load(he), e.load(Le), e.load(Qe), e.load(tt), e.load(Wt), e.load(qt), e.load(en), e.load(qn), e.load(Nn), e.load(Yn), e.load(ur), function (e) {
      e.bind(p.f).to(dr.a).inSingletonScope(), e.bind(p.d).to(pr.a).inSingletonScope(), cr.a.with(e), sr.a.with(e), lr.a.with(e), fr.a.with(e);
    }(e), e;
  }
  function br() {
    return or || (or = vr()), or;
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  }), n.d(t, "b", function () {
    return o;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("TelemetrySdkClient"),
    o = Symbol.for("TelemetrySdkErrorEventGroup");
}, function (e, t, n) {
  "use strict";

  n.d(t, "c", function () {
    return h;
  }), n.d(t, "b", function () {
    return y;
  }), n.d(t, "a", function () {
    return m;
  });
  n(26), n(9), n(14), n(3), n(36), n(5), n(6), n(7);
  var r = n(92),
    o = n.n(r),
    i = n(93),
    a = n.n(i),
    u = n(104),
    c = n.n(u),
    s = n(105),
    l = n.n(s),
    f = n(25);
  function d(e) {
    return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  var p = function e(t, n) {
      var r = [];
      return t.forEach(function (t) {
        var o;
        o = Array.isArray(t) ? e(t, n) : "object" === d(t) ? v(t, n) : t, r.push(o);
      }), r;
    },
    v = function e(t, n) {
      return l()(t, function (t, r, o) {
        Array.isArray(r) ? t["".concat(n(o))] = p(r, n) : r instanceof Object && !(r instanceof Date) ? t["".concat(n(o))] = e(r, n) : t["".concat(n(o))] = r;
      }, {});
    },
    b = function b(e, t) {
      return c()(e, function (e, n) {
        return t(n);
      });
    },
    h = function h(e) {
      return b(e, function (e) {
        return a()(e);
      });
    },
    y = function y(e) {
      return b(e, function (e) {
        return o()(e);
      });
    },
    m = function m(e) {
      return Object(f.b)(e, "key-value dictionary"), v(e, function (e) {
        return a()(e);
      });
    };
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("Session"),
    o = Symbol.for("SessionOptions");
}, function (e, t) {
  e.exports = require("core-js/modules/es.map.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return r;
  }), n.d(t, "c", function () {
    return o;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("Client"),
    o = Symbol.for("ClientProvider"),
    i = Symbol.for("ClientOptions"),
    a = Symbol.for("ClientMockOptions");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return O;
  });
  n(27), n(5), n(3), n(6), n(13), n(7), n(56), n(57), n(64), n(50), n(31), n(9), n(43), n(35), n(26), n(44), n(14), n(36);
  var r = n(40),
    o = n(66);
  function i(e) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function a(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function c(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function s(e, t) {
    return !t || "object" !== i(t) && "function" != typeof t ? l(e) : t;
  }
  function l(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function f(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (f = function f(e) {
      if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
      var n;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }
      function r() {
        return d(e, arguments, b(this).constructor);
      }
      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), v(r, e);
    })(e);
  }
  function d(e, t, n) {
    return (d = p() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && v(o, n.prototype), o;
    }).apply(null, arguments);
  }
  function p() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }
  function v(e, t) {
    return (v = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function b(e) {
    return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function h(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, m(e, t, "get"));
  }
  function y(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, m(e, t, "set"), n), n;
  }
  function m(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var w = new WeakMap(),
    g = new WeakMap(),
    j = new WeakMap(),
    k = new WeakMap(),
    O = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && v(e, t);
      }(O, e);
      var t,
        n,
        i,
        f,
        d,
        m = (t = O, n = p(), function () {
          var e,
            r = b(t);
          if (n) {
            var o = b(this).constructor;
            e = Reflect.construct(r, arguments, o);
          } else e = r.apply(this, arguments);
          return s(this, e);
        });
      function O(e, t, n, i) {
        var a;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, O), a = m.call(this, "".concat(Object(r.a)(e) + (void 0 !== n ? ": ".concat(n) : ""), " (").concat(e, ")")), w.set(l(a), {
          writable: !0,
          value: void 0
        }), g.set(l(a), {
          writable: !0,
          value: void 0
        }), j.set(l(a), {
          writable: !0,
          value: void 0
        }), k.set(l(a), {
          writable: !0,
          value: void 0
        }), y(l(a), g, e), y(l(a), w, n), y(l(a), k, t || {
          severity: o.a.Error
        }), y(l(a), j, i), Object.setPrototypeOf(l(a), O.prototype), a;
      }
      return i = O, (f = [{
        key: "code",
        get: function get() {
          return h(this, g);
        }
      }, {
        key: "details",
        get: function get() {
          return h(this, w);
        }
      }, {
        key: "wrappedError",
        get: function get() {
          return h(this, j);
        }
      }, {
        key: "metadata",
        get: function get() {
          return function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? a(Object(n), !0).forEach(function (t) {
                u(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }({}, h(this, k));
        }
      }]) && c(i.prototype, f), d && c(i, d), O;
    }(f(Error));
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.includes.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.includes.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.regexp.exec.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.get-prototype-of.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.regexp.to-string.js");
}, function (e, t, n) {
  "use strict";

  var r, o, i;
  n.d(t, "a", function () {
    return r;
  }), n.d(t, "b", function () {
    return o;
  }), n.d(t, "c", function () {
    return i;
  }), function (e) {
    e.Client = "flex:Client", e.Error = "flex:Error", e.Session = "flex:Session", e.Twilsock = "flex:Twilsock", e.Auth = "flex:Auth", e.Config = "flex:Config", e.RateLimiter = "flex:RateLimiter", e.Sync = "flex:Sync", e.SyncAdapter = "flex:SyncAdapter", e.QueueStats = "flex:QueueStats", e.Storage = "flex:Storage";
  }(r || (r = {})), function (e) {
    e.Twilsock = "twilsock";
  }(o || (o = {})), function (e) {
    e.TelemetryClient = "TelemetryClient", e.TelemetryProcessor = "TelemetryProcessor", e.TelemetrySdkClient = "TelemetrySdkClient";
  }(i || (i = {}));
}, function (e, t) {
  e.exports = require("events");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });
  n(9), n(14), n(3);
  var r = Symbol.for("eventEmitter");
}, function (e, t) {
  e.exports = require("loglevel");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  });
  n(17), n(3), n(11), n(6), n(5), n(7), n(9), n(14), n(36);
  var r = n(1);
  function o(e) {
    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function i(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function a(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var a = e.apply(t, n);
        function u(e) {
          i(a, r, o, u, c, "next", e);
        }
        function c(e) {
          i(a, r, o, u, c, "throw", e);
        }
        u(void 0);
      });
    };
  }
  function u(e, t, n) {
    return "exponential" === n ? Math.pow(1.5, e) * t : (e + 1) * t;
  }
  function c(e) {
    return s.apply(this, arguments);
  }
  function s() {
    return (s = a(_regeneratorRuntime().mark(function e(t) {
      var n, i, a, c, s, l, f, d;
      return _regeneratorRuntime().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (n = 0, i = 9e5, a = void 0 !== t.initialDelay ? t.initialDelay : 100, c = void 0 !== t.maxAttempts ? t.maxAttempts : 3, s = t.backoff || "exponential", !(c < 1)) {
              e.next = 7;
              break;
            }
            throw new r.d("The value of max retry attempts has to be bigger than 0");
          case 7:
            f = _regeneratorRuntime().mark(function e() {
              var r;
              return _regeneratorRuntime().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.prev = 0, t.logger && n > 0 && t.logger.debug("Retry attempt: ", n), e.next = 4, t.functionToRetry();
                  case 4:
                    return e.t0 = e.sent, e.abrupt("return", {
                      v: e.t0
                    });
                  case 8:
                    if (e.prev = 8, e.t1 = e.catch(0), t.retryCondition(e.t1)) {
                      e.next = 12;
                      break;
                    }
                    return e.abrupt("return", {
                      v: Promise.reject(e.t1)
                    });
                  case 12:
                    if (!(n >= c - 1)) {
                      e.next = 15;
                      break;
                    }
                    return l = e.t1, e.abrupt("return", "break");
                  case 15:
                    return (r = u(n, a, s)) > i && (r = i), e.next = 19, new Promise(function (e) {
                      return setTimeout(e, r);
                    });
                  case 19:
                  case "end":
                    return e.stop();
                }
              }, e, null, [[0, 8]]);
            });
          case 8:
            return e.delegateYield(f(), "t0", 9);
          case 9:
            if ("break" !== (d = e.t0)) {
              e.next = 12;
              break;
            }
            return e.abrupt("break", 15);
          case 12:
            if ("object" !== o(d)) {
              e.next = 14;
              break;
            }
            return e.abrupt("return", d.v);
          case 14:
            if (n++ < c - 1) {
              e.next = 8;
              break;
            }
          case 15:
            return e.abrupt("return", Promise.reject(l));
          case 16:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.slice.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.reflect.construct.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.replace.js");
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.Fatal = "fatal", e.Error = "error", e.Warning = "warning", e.Info = "info";
  }(r || (r = {}));
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.AccountConfig = "FLEX_SDK_CACHE_ACCOUNT_CONFIG", e.PublicConfig = "FLEX_SDK_CACHE_PUBLIC_CONFIG", e.FeaturesConfig = "FLEX_SDK_CACHE_FEATURES_CONFIG";
  }(r || (r = {}));
}, function (e) {
  e.exports = JSON.parse('{"a":"0.9.1"}');
}, function (e, t) {
  e.exports = require("lodash/cloneDeep");
}, function (e, t, n) {
  "use strict";

  var r = n(28);
  n.d(t, "b", function () {
    return r.b;
  }), n.d(t, "a", function () {
    return r.a;
  });
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  }), n.d(t, "b", function () {
    return d;
  });
  n(56), n(3), n(57), n(64), n(5), n(50), n(6), n(7), n(9), n(14), n(36);
  function r(e) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function o(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function i(e, t) {
    return !t || "object" !== r(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }
  function a(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (a = function a(e) {
      if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
      var n;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }
      function r() {
        return u(e, arguments, l(this).constructor);
      }
      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), s(r, e);
    })(e);
  }
  function u(e, t, n) {
    return (u = c() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && s(o, n.prototype), o;
    }).apply(null, arguments);
  }
  function c() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }
  function s(e, t) {
    return (s = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function l(e) {
    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  var f = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && s(e, t);
    }(a, e);
    var t,
      n,
      r = (t = a, n = c(), function () {
        var e,
          r = l(t);
        if (n) {
          var o = l(this).constructor;
          e = Reflect.construct(r, arguments, o);
        } else e = r.apply(this, arguments);
        return i(this, e);
      });
    function a() {
      return o(this, a), r.apply(this, arguments);
    }
    return a;
  }(a(Error));
  function d(e) {
    var t = Object.prototype.hasOwnProperty.call(e, "reply"),
      n = t && Object.prototype.hasOwnProperty.call(e.reply, "status"),
      r = n && Object.prototype.hasOwnProperty.call(e.reply.status, "code");
    return t && n && r;
  }
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.reduce.js");
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.TokenExpired = "tokenExpired", e.TokenAboutToExpire = "tokenAboutToExpire", e.StateChanged = "stateChanged", e.ConnectionError = "connectionError", e.Connected = "connected", e.Disconnected = "disconnected", e.TokenUpdated = "tokenUpdated";
  }(r || (r = {}));
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.from.js");
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.Guest = "guest", e.Agent = "agent", e.Admin = "admin", e.Supervisor = "supervisor";
  }(r || (r = {}));
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return a;
  });
  var r = n(69),
    o = n.n(r),
    i = {
      autoUpdateToken: !0
    };
  function a() {
    return o()(i);
  }
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return h;
    });
    n(3), n(11), n(17);
    var o = n(15),
      i = n(18),
      a = n(100),
      u = n(25),
      c = n(19),
      s = n(4),
      l = n(1),
      f = n(2);
    function d(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function p(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function v(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);
          function a(e) {
            p(i, r, o, a, u, "next", e);
          }
          function u(e) {
            p(i, r, o, a, u, "throw", e);
          }
          a(void 0);
        });
      };
    }
    var b = function () {
      var e = v(_regeneratorRuntime().mark(function e(t, n, r) {
        var o;
        return _regeneratorRuntime().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, o = n.createEventGroup(c.b.Default), e.next = 4, o.addEvents({
                eventName: c.c.ClientInitialized,
                eventSource: c.d.Client,
                durationMs: r
              });
            case 4:
              e.next = 9;
              break;
            case 6:
              e.prev = 6, e.t0 = e.catch(0), t.error("Failed to send client init event", e.t0);
            case 9:
            case "end":
              return e.stop();
          }
        }, e, null, [[0, 6]]);
      }));
      return function (t, n, r) {
        return e.apply(this, arguments);
      };
    }();
    function h(e, t, n) {
      return y.apply(this, arguments);
    }
    function y() {
      return (y = v(_regeneratorRuntime().mark(function t(n, p, v) {
        var h, y, m, w, g, j, k, O, S, x, E, T;
        return _regeneratorRuntime().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return h = Date.now(), Object(u.c)(p, "token"), y = n.get(o.b), m = n.get(s.d), w = m(s.b.Client), g = n.get(l.g), j = n.get(l.e), Object(a.a)(y, v), k = n.get(i.c), t.prev = 9, t.next = 12, k.init(p);
            case 12:
              t.next = 18;
              break;
            case 14:
              t.prev = 14, t.t0 = t.catch(9), O = {
                module: Object(f.b)(e),
                severity: l.b.Error,
                source: Object(f.a)(r)
              }, 51102 === t.t0.code || 20003 === t.t0.code ? (O.source = "Twilsock", g(l.a.Forbidden, O, "Insufficient permissions", t.t0.source)) : j(t.t0, O);
            case 18:
              return t.prev = 18, S = {
                dependencies: d({}, c.a.Twilsock, "default")
              }, x = n.get(c.e), t.next = 23, x.setSessionData(S);
            case 23:
              return E = Date.now() - h, t.next = 26, b(w, x, E);
            case 26:
              t.next = 31;
              break;
            case 28:
              t.prev = 28, t.t1 = t.catch(18), w.error("Failed to set session data for telemetry", t.t1);
            case 31:
              return T = n.get(o.d), t.abrupt("return", T);
            case 33:
            case "end":
              return t.stop();
          }
        }, t, null, [[9, 14], [18, 28]]);
      }))).apply(this, arguments);
    }
  }).call(this, "src/modules/client/ClientProvider", "src/modules/client/ClientProvider/createClient.ts");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return g;
  });
  n(5), n(3), n(6), n(13), n(7);
  var r,
    o,
    i,
    a,
    u,
    c,
    s,
    l,
    f = n(0),
    d = n(18),
    p = n(4),
    v = n(32),
    b = n(8);
  function h(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function y(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, w(e, t, "get"));
  }
  function m(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, w(e, t, "set"), n), n;
  }
  function w(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var g = Object(f.injectable)()((o = new WeakMap(), i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), l = new WeakMap(), r = function () {
    function e(t, n, r, f) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o.set(this, {
        writable: !0,
        value: void 0
      }), i.set(this, {
        writable: !0,
        value: void 0
      }), a.set(this, {
        writable: !0,
        value: void 0
      }), u.set(this, {
        writable: !0,
        value: void 0
      }), c.set(this, {
        writable: !0,
        value: void 0
      }), s.set(this, {
        writable: !0,
        value: void 0
      }), l.set(this, {
        writable: !0,
        value: void 0
      }), m(this, o, t), m(this, i, n), m(this, a, r), m(this, u, f);
    }
    var t, n, r;
    return e = Object(f.inject)(b.a)(e, void 0, 3) || e, e = Object(f.inject)(v.e)(e, void 0, 2) || e, e = Object(f.inject)(p.e)(e, void 0, 1) || e, e = Object(f.inject)(d.b)(e, void 0, 0) || e, t = e, (n = [{
      key: "session",
      get: function get() {
        return y(this, o);
      }
    }, {
      key: "logger",
      get: function get() {
        return y(this, i);
      }
    }, {
      key: "telemetry",
      get: function get() {
        return y(this, a);
      }
    }, {
      key: "accountConfig",
      get: function get() {
        return y(this, u);
      }
    }, {
      key: "region",
      get: function get() {
        return y(this, c);
      },
      set: function set(e) {
        m(this, c, e);
      }
    }, {
      key: "appName",
      get: function get() {
        return y(this, s);
      },
      set: function set(e) {
        m(this, s, e);
      }
    }, {
      key: "appVersion",
      get: function get() {
        return y(this, l);
      },
      set: function set(e) {
        m(this, l, e);
      }
    }]) && h(t.prototype, n), r && h(t, r), e;
  }())) || r;
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });
  n(5), n(3), n(6), n(13), n(7);
  var r,
    o,
    i = n(0),
    a = n(1);
  function u(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function c(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, l(e, t, "set"), n), n;
  }
  function s(e, t) {
    return function (e, t) {
      if (t.get) return t.get.call(e);
      return t.value;
    }(e, l(e, t, "get"));
  }
  function l(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var f = Object(i.injectable)()((o = new WeakMap(), r = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o.set(this, {
        writable: !0,
        value: void 0
      });
    }
    var t, n, r;
    return t = e, (n = [{
      key: "get",
      value: function value() {
        if (!s(this, o)) throw new a.d("Config data hasn't been fetched");
        return s(this, o);
      }
    }, {
      key: "set",
      value: function value(e) {
        c(this, o, e);
      }
    }]) && u(t.prototype, n), r && u(t, r), e;
  }())) || r;
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });
  n(3), n(11), n(17);
  var r = n(21);
  function o(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  var i = function i(e) {
    return function () {
      var t,
        n = (t = _regeneratorRuntime().mark(function t(n, o) {
          var i, a;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return i = e.get(r.b), t.next = 3, i(n, o);
              case 3:
                return a = t.sent, t.abrupt("return", a.get());
              case 5:
              case "end":
                return t.stop();
            }
          }, t);
        }), function () {
          var e = this,
            n = arguments;
          return new Promise(function (r, i) {
            var a = t.apply(e, n);
            function u(e) {
              o(a, r, i, u, c, "next", e);
            }
            function c(e) {
              o(a, r, i, u, c, "throw", e);
            }
            u(void 0);
          });
        });
      return function (e, t) {
        return n.apply(this, arguments);
      };
    }();
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return d;
  });
  n(53), n(54), n(31), n(72);
  var r = n(109),
    o = n.n(r),
    i = n(20),
    a = n(25),
    u = n(58);
  var c,
    s,
    l,
    f = (c = {}, s = u.b.Twilsock, l = o.a, s in c ? Object.defineProperty(c, s, {
      value: l,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[s] = l, c),
    d = function d(e) {
      return function (t) {
        Object(a.e)(t, "name");
        var n = e.get(i.c),
          r = n.get(t);
        if (r) return r;
        var o,
          u = e.get(i.d).level,
          c = e.get(i.e),
          s = e.get(i.a);
        return o = Object.keys(f).includes(t) ? function (e) {
          return f[e].getLogger(e);
        }(t) : c(t), o = s.reduce(function (e, t) {
          return t(e);
        }, o), (r = new (e.get(i.f))(o)).setLevel(u), n.set(t, r), r;
      };
    };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return a;
  });
  var r = n(69),
    o = n.n(r),
    i = {
      level: "ERROR"
    };
  function a() {
    return o()(i);
  }
}, function (e, t, n) {
  "use strict";

  function r() {
    return {
      reportErrors: !0
    };
  }
  n.d(t, "a", function () {
    return r;
  });
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return o;
  });
  n(26);
  var r = n(28);
  function o(e) {
    var t = e.get(r.c);
    t.forEach(function (e) {
      return e.cleanup();
    }), t.clear();
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return o;
  });
  n(38);
  var r = n(28);
  function o(e, t) {
    var n = e.get(r.c),
      o = n.get(t.name);
    return o || ((o = e.get(r.d)).setup(t), n.set(t.name, o)), o;
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });
  var r = n(112);
  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  var i = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }
    var t, n, i;
    return t = e, i = [{
      key: "with",
      value: function value(e) {
        e.bind("TelemetryService").to(r.a).inSingletonScope();
      }
    }], (n = null) && o(t.prototype, n), i && o(t, i), e;
  }();
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });
  var r = n(113);
  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  var i = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }
    var t, n, i;
    return t = e, i = [{
      key: "with",
      value: function value(e) {
        e.bind("ConfigurationService").to(r.a).inSingletonScope();
      }
    }], (n = null) && o(t.prototype, n), i && o(t, i), e;
  }();
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });
  var r = n(114);
  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  var i = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }
    var t, n, i;
    return t = e, i = [{
      key: "with",
      value: function value(e) {
        e.bind("FederatedAuthService").to(r.a).inSingletonScope();
      }
    }], (n = null) && o(t.prototype, n), i && o(t, i), e;
  }();
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });
  n(17), n(5), n(3), n(6), n(13), n(7), n(11);
  var r,
    o,
    i = n(0),
    a = n(10);
  function u(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function c(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function s(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, l(e, t, "set"), n), n;
  }
  function l(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
    return t.get(e);
  }
  var f = Object(i.injectable)()((o = new WeakMap(), r = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o.set(this, {
        writable: !0,
        value: void 0
      }), s(this, o, t);
    }
    var t, n, r, f, d;
    return e = Object(i.inject)(a.b)(e, void 0, 0) || e, t = e, (n = [{
      key: "post",
      value: (f = _regeneratorRuntime().mark(function e(t, n) {
        var r;
        return _regeneratorRuntime().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, (i = this, a = o, function (e, t) {
                return t.get ? t.get.call(e) : t.value;
              }(i, l(i, a, "get"))).post(t, {}, n);
            case 2:
              return r = e.sent, e.abrupt("return", r);
            case 4:
            case "end":
              return e.stop();
          }
          var i, a;
        }, e, this);
      }), d = function d() {
        var e = this,
          t = arguments;
        return new Promise(function (n, r) {
          var o = f.apply(e, t);
          function i(e) {
            u(o, n, r, i, a, "next", e);
          }
          function a(e) {
            u(o, n, r, i, a, "throw", e);
          }
          i(void 0);
        });
      }, function (e, t) {
        return d.apply(this, arguments);
      })
    }]) && c(t.prototype, n), r && c(t, r), e;
  }())) || r;
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return x;
    });
    n(17), n(5), n(3), n(6), n(13), n(7), n(11), n(123), n(55), n(65);
    var r,
      o,
      i,
      a,
      u,
      c,
      s,
      l = n(0),
      f = n(1),
      d = n(18),
      p = n(8),
      v = n(48),
      b = n(2),
      h = n(62),
      y = n(115),
      m = n(45);
    function w(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function g(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);
          function a(e) {
            w(i, r, o, a, u, "next", e);
          }
          function u(e) {
            w(i, r, o, a, u, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function j(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function k(e, t) {
      return function (e, t) {
        if (t.get) return t.get.call(e);
        return t.value;
      }(e, S(e, t, "get"));
    }
    function O(e, t, n) {
      return function (e, t, n) {
        if (t.set) t.set.call(e, n);else {
          if (!t.writable) throw new TypeError("attempted to set read only private field");
          t.value = n;
        }
      }(e, S(e, t, "set"), n), n;
    }
    function S(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
      return t.get(e);
    }
    var x = Object(l.injectable)()((o = new WeakMap(), i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), r = function () {
      function t(n, r, l, d) {
        var p,
          h,
          y = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o.set(this, {
          writable: !0,
          value: void 0
        }), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: function value(e) {
            var t;
            return 429 === e ? t = f.a.TooManyRequests : e >= 500 && (t = f.a.Unknown), t;
          }
        }), u.set(this, {
          writable: !0,
          value: (p = g(_regeneratorRuntime().mark(function t(n) {
            var r, u;
            return _regeneratorRuntime().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return r = {
                    module: "backend",
                    severity: f.b.Error,
                    source: Object(b.a)(e)
                  }, (u = k(y, a).call(y, n.status)) && k(y, o).call(y, u, r), t.next = 5, k(y, i).call(y, n, r);
                case 5:
                case "end":
                  return t.stop();
              }
            }, t);
          })), function (e) {
            return p.apply(this, arguments);
          })
        }), c.set(this, {
          writable: !0,
          value: (h = g(_regeneratorRuntime().mark(function e(t, n, r, o, i) {
            var a, c, s;
            return _regeneratorRuntime().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return a = y.getEnvironmentSpecificUrl(t), e.prev = 1, e.next = 4, fetch(a, y.getRequestData(n, r, y.mapBody(o), i));
                case 4:
                  c = e.sent, e.next = 10;
                  break;
                case 7:
                  throw e.prev = 7, e.t0 = e.catch(1), new f.c(f.a.NetworkError, void 0, void 0, e.t0);
                case 10:
                  if (c.ok) {
                    e.next = 13;
                    break;
                  }
                  return e.next = 13, k(y, u).call(y, c);
                case 13:
                  return e.next = 15, c.json();
                case 15:
                  return s = e.sent, e.abrupt("return", Object(v.b)(s));
                case 17:
                case "end":
                  return e.stop();
              }
            }, e, null, [[1, 7]]);
          })), function (e, t, n, r, o) {
            return h.apply(this, arguments);
          })
        }), s.set(this, {
          writable: !0,
          value: function value(e) {
            if (!e) return y.session.token;
            if ("string" == typeof e) return e;
            throw new f.d("No token in request body");
          }
        }), this.session = n, this.envConfig = r, O(this, o, l), O(this, i, d);
      }
      var n, r, w, S;
      return t = Object(l.inject)(f.f)(t, void 0, 3) || t, t = Object(l.inject)(f.g)(t, void 0, 2) || t, t = Object(l.inject)(p.e)(t, void 0, 1) || t, t = Object(l.inject)(d.c)(t, void 0, 0) || t, n = t, (r = [{
        key: "get",
        value: function value(e, t, n) {
          return this.performNetworkCall(e, "GET", t, void 0, n);
        }
      }, {
        key: "post",
        value: function value(e, t, n, r) {
          return this.performNetworkCall(e, "POST", t, n, r);
        }
      }, {
        key: "put",
        value: function value(e, t, n) {
          return this.performNetworkCall(e, "PUT", t, n);
        }
      }, {
        key: "delete",
        value: function value(e, t) {
          return this.performNetworkCall(e, "DELETE", t);
        }
      }, {
        key: "getRequestData",
        value: function value(e, t, n, r) {
          return {
            headers: t ? Object(m.b)(t, k(this, s).call(this, null == r ? void 0 : r.token)) : new Headers({
              "Content-Type": "application/json"
            }),
            method: e,
            body: JSON.stringify(n)
          };
        }
      }, {
        key: "getEnvironmentSpecificUrl",
        value: function value(e) {
          var t = "",
            n = this.envConfig.region || "";
          return n.startsWith("dev-") ? t = ".dev" : n.startsWith("stage-") && (t = ".stage"), e.replace("[environment]", t);
        }
      }, {
        key: "mapBody",
        value: function value(e) {
          return e ? Object(v.c)(e) : e;
        }
      }, {
        key: "performNetworkCall",
        value: (S = g(_regeneratorRuntime().mark(function e(t, n, r, o, i) {
          var a = this;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", Object(h.a)({
                  functionToRetry: function functionToRetry() {
                    return k(a, c).call(a, t, n, r, o, i);
                  },
                  retryCondition: y.a
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        })), function (e, t, n, r, o) {
          return S.apply(this, arguments);
        })
      }]) && j(n.prototype, r), w && j(n, w), t;
    }())) || r;
  }).call(this, "src/backend/HttpAdapter/HttpAdapterImpl.ts");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return b;
  });
  n(17), n(5), n(3), n(6), n(13), n(7), n(11);
  var r,
    o,
    i = n(0),
    a = n(1),
    u = n(16),
    c = n(45),
    s = n(41);
  function l(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
        c = u.value;
    } catch (e) {
      return void n(e);
    }
    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }
  function f(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function d(e, t, n) {
    return function (e, t, n) {
      if (t.set) t.set.call(e, n);else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = n;
      }
    }(e, function (e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
      return t.get(e);
    }(e, t, "set"), n), n;
  }
  var p = Object(i.injectable)()((o = new WeakMap(), r = function () {
    function e(t, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o.set(this, {
        writable: !0,
        value: void 0
      }), this.httpAdapter = t, d(this, o, n);
    }
    var t, n, r, p, v;
    return e = Object(i.inject)(a.g)(e, void 0, 1) || e, e = Object(i.inject)(u.d)(e, void 0, 0) || e, t = e, (n = [{
      key: "fetchFeatures",
      value: (p = _regeneratorRuntime().mark(function e() {
        var t, n;
        return _regeneratorRuntime().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.httpAdapter.get("https://flex[environment].twilio.com/api/v1/Session", c.a.HostedFlex);
            case 2:
              return t = e.sent, n = Object(s.a)(t), e.abrupt("return", n);
            case 5:
            case "end":
              return e.stop();
          }
        }, e, this);
      }), v = function v() {
        var e = this,
          t = arguments;
        return new Promise(function (n, r) {
          var o = p.apply(e, t);
          function i(e) {
            l(o, n, r, i, a, "next", e);
          }
          function a(e) {
            l(o, n, r, i, a, "throw", e);
          }
          i(void 0);
        });
      }, function () {
        return v.apply(this, arguments);
      })
    }]) && f(t.prototype, n), r && f(t, r), e;
  }())) || r;
  function v(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  var b = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }
    var t, n, r;
    return t = e, r = [{
      key: "with",
      value: function value(e) {
        e.bind("FeaturesService").to(p).inSingletonScope();
      }
    }], (n = null) && v(t.prototype, n), r && v(t, r), e;
  }();
}, function (e, t) {
  e.exports = require("lodash/camelCase");
}, function (e, t) {
  e.exports = require("lodash/snakeCase");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.values.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.number.constructor.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.trim.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.match.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.map.js");
}, function (e, t) {
  e.exports = require("twilsock");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return s;
    });
    n(56);
    var o = n(101),
      i = n.n(o),
      a = n(1),
      u = n(2),
      c = n(25);
    function s(t, n) {
      void 0 !== n && Object(c.d)(n, "userOptions");
      i()(t, n, function (t, n, o, i, c) {
        var s = Object.prototype.hasOwnProperty.call(i, o),
          l = Object.prototype.hasOwnProperty.call(Object.getPrototypeOf(i), o);
        if (!s && !l) {
          var f = {
            module: Object(u.b)(e),
            severity: a.b.Error,
            source: Object(u.a)(r)
          };
          throw new a.c(a.a.InvalidParams, f, "".concat(o, " is not a valid property"));
        }
      });
    }
  }).call(this, "src/utils", "src/utils/mergeUserOptions.ts");
}, function (e, t) {
  e.exports = require("lodash/mergeWith");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return h;
    });
    n(3), n(11), n(31), n(9), n(43), n(35), n(26), n(44), n(17);
    var o = n(8),
      i = n(4),
      a = n(1),
      u = n(33),
      c = n(15),
      s = n(16),
      l = n(2);
    function f(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function d(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? f(Object(n), !0).forEach(function (t) {
          p(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function p(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function v(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    var b = {
        module: Object(l.b)(e),
        eventSource: Object(l.a)(r)
      },
      h = function h(e) {
        return function () {
          var t,
            n = (t = _regeneratorRuntime().mark(function t(n) {
              var r,
                l,
                f,
                p,
                v,
                h,
                y,
                m,
                w,
                g,
                j,
                k,
                O,
                S,
                x,
                E = arguments;
              return _regeneratorRuntime().wrap(function (t) {
                for (;;) switch (t.prev = t.next) {
                  case 0:
                    return f = E.length > 1 && void 0 !== E[1] ? E[1] : {}, p = e.get(o.d), v = e.get(s.a), h = e.get(a.g), y = e.get(u.b), m = e.get(i.d)(i.b.Config), w = e.get(c.b), j = (null == w || null === (r = w.accountConfig.query) || void 0 === r ? void 0 : r.UiVersion) || (null == f || null === (l = f.query) || void 0 === l ? void 0 : l.UiVersion), t.prev = 8, t.next = 11, v.fetchConfiguration("UiVersion", j, {
                      token: n
                    });
                  case 11:
                    g = t.sent, y.setCachedItem(u.a.AccountConfig, g), t.next = 24;
                    break;
                  case 15:
                    if (t.prev = 15, t.t0 = t.catch(8), void 0 !== (k = y.getCachedItem(u.a.AccountConfig))) {
                      t.next = 22;
                      break;
                    }
                    return O = "Failed to fetch account configuration: ".concat(t.t0, ". No cache found."), S = t.t0.code || a.a.Unknown, t.abrupt("return", h(S, d(d({}, b), {}, {
                      severity: a.b.Error
                    }), O));
                  case 22:
                    m.warn("Failed to fetch account configuration: ".concat(t.t0, ". Using cache instead")), g = k;
                  case 24:
                    return p.set(g), x = e.get(o.c), t.abrupt("return", x);
                  case 27:
                  case "end":
                    return t.stop();
                }
              }, t, null, [[8, 15]]);
            }), function () {
              var e = this,
                n = arguments;
              return new Promise(function (r, o) {
                var i = t.apply(e, n);
                function a(e) {
                  v(i, r, o, a, u, "next", e);
                }
                function u(e) {
                  v(i, r, o, a, u, "throw", e);
                }
                a(void 0);
              });
            });
          return function (e) {
            return n.apply(this, arguments);
          };
        }();
      };
  }).call(this, "src/modules/config/AccountConfigProvider", "src/modules/config/AccountConfigProvider/AccountConfigProvider.ts");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return m;
    });
    n(17), n(96), n(120), n(55), n(65), n(97), n(3), n(11), n(31), n(9), n(43), n(35), n(26), n(44);
    var o = n(1),
      i = n(33),
      a = n(16),
      u = n(48),
      c = n(2),
      s = n(4);
    function l(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function f(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? l(Object(n), !0).forEach(function (t) {
          d(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function d(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function p(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function v(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);
          function a(e) {
            p(i, r, o, a, u, "next", e);
          }
          function u(e) {
            p(i, r, o, a, u, "throw", e);
          }
          a(void 0);
        });
      };
    }
    var b = /^([a-z]+-[a-z]+-\d+)$/,
      h = {
        module: Object(c.b)(e),
        eventSource: Object(c.a)(r)
      };
    function y(e) {
      return function (e) {
        return !!e.accountSid;
      }(e) ? {
        paramName: "AccountSid",
        paramValue: e.accountSid
      } : {
        paramName: "RuntimeDomain",
        paramValue: function (e) {
          var t = e.trim();
          if (t.endsWith("/") && (t = t.replace(/\/$/, "")), !t.endsWith(".twil.io")) {
            var n = t.match(b);
            n && n[1] && (t += ".twil.io");
          }
          return t;
        }(e.runtimeDomain)
      };
    }
    function m(e, t) {
      return w.apply(this, arguments);
    }
    function w() {
      return (w = v(_regeneratorRuntime().mark(function e(t, n) {
        var r, c, l, d, p, v, b, m, w;
        return _regeneratorRuntime().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return r = t.get(a.a), c = t.get(o.g), l = t.get(i.b), d = t.get(s.d)(s.b.Config), p = y(n), e.prev = 5, e.next = 8, r.fetchPublicConfiguration(p.paramName, p.paramValue);
            case 8:
              v = e.sent, l.setCachedItem(i.a.PublicConfig, v), e.next = 21;
              break;
            case 12:
              if (e.prev = 12, e.t0 = e.catch(5), void 0 !== (b = l.getCachedItem(i.a.PublicConfig))) {
                e.next = 19;
                break;
              }
              return m = "Failed to fetch public configuration: ".concat(e.t0, ". No cache found."), w = e.t0.code || o.a.Unknown, e.abrupt("return", c(w, f(f({}, h), {}, {
                severity: o.b.Error
              }), m));
            case 19:
              d.warn("Failed to fetch public configuration: ".concat(e.t0, ". Using cache instead")), v = b;
            case 21:
              return v && v.configurations && v.configurations.length || c(o.a.SDK, f(f({}, h), {}, {
                severity: o.b.Error
              }), "Invalid response from public configuration endpoint"), e.abrupt("return", Object(u.b)(v.configurations[0]));
            case 23:
            case "end":
              return e.stop();
          }
        }, e, null, [[5, 12]]);
      }))).apply(this, arguments);
    }
  }).call(this, "src/modules/config/PublicConfigProvider", "src/modules/config/PublicConfigProvider/getPublicConfig.ts");
}, function (e, t) {
  e.exports = require("lodash/mapKeys");
}, function (e, t) {
  e.exports = require("lodash/transform");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return b;
    });
    n(3), n(11), n(31), n(9), n(43), n(35), n(26), n(44), n(17);
    var o = n(4),
      i = n(1),
      a = n(33),
      u = n(16),
      c = n(2);
    function s(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function l(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? s(Object(n), !0).forEach(function (t) {
          f(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function f(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function d(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function p(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);
          function a(e) {
            d(i, r, o, a, u, "next", e);
          }
          function u(e) {
            d(i, r, o, a, u, "throw", e);
          }
          a(void 0);
        });
      };
    }
    var v = {
        module: Object(c.b)(e),
        eventSource: Object(c.a)(r)
      },
      b = function b(e) {
        var t = e.container;
        return p(_regeneratorRuntime().mark(function e() {
          var n, r, c, s, f, d, p, b;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return n = t.get(u.b), r = t.get(i.g), c = t.get(a.b), s = t.get(o.d)(o.b.Config), e.prev = 4, e.next = 7, n.fetchFeatures();
              case 7:
                f = e.sent, c.setCachedItem(a.a.FeaturesConfig, f), e.next = 20;
                break;
              case 11:
                if (e.prev = 11, e.t0 = e.catch(4), void 0 !== (d = c.getCachedItem(a.a.FeaturesConfig))) {
                  e.next = 18;
                  break;
                }
                return p = "Failed to fetch features: ".concat(e.t0, ". No cache found."), b = e.t0.code || i.a.Unknown, e.abrupt("return", r(b, l(l({}, v), {}, {
                  severity: i.b.Error
                }), p));
              case 18:
                s.warn("Failed to fetch features: ".concat(e.t0, ". Using cache instead")), f = d;
              case 20:
                return e.abrupt("return", f);
              case 21:
              case "end":
                return e.stop();
            }
          }, e, null, [[4, 11]]);
        }));
      };
  }).call(this, "src/modules/config/FeaturesProvider/featuresProviderImpl", "src/modules/config/FeaturesProvider/featuresProviderImpl/featuresProviderImpl.ts");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return z;
    });
    n(17), n(5), n(3), n(6), n(13), n(7), n(27), n(11);
    var o,
      i,
      a,
      u,
      c,
      s,
      l,
      f,
      d,
      p,
      v,
      b,
      h,
      y,
      m,
      w,
      g,
      j,
      k,
      O = n(0),
      S = n(61),
      x = n.n(S),
      E = n(68),
      T = n(23),
      C = n(37),
      P = n(29),
      R = n(10),
      M = n(1),
      A = n(4),
      I = n(8),
      W = n(15),
      F = n(62),
      D = n(2),
      q = n(71);
    function L(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function N(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);
          function a(e) {
            L(i, r, o, a, u, "next", e);
          }
          function u(e) {
            L(i, r, o, a, u, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function _(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function U(e, t) {
      return function (e, t) {
        if (t.get) return t.get.call(e);
        return t.value;
      }(e, K(e, t, "get"));
    }
    function V(e, t, n) {
      return function (e, t, n) {
        if (t.set) t.set.call(e, n);else {
          if (!t.writable) throw new TypeError("attempted to set read only private field");
          t.value = n;
        }
      }(e, K(e, t, "set"), n), n;
    }
    function K(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
      return t.get(e);
    }
    var z = Object(O.injectable)()((i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), l = new WeakMap(), f = new WeakMap(), d = new WeakMap(), p = new WeakMap(), v = new WeakMap(), b = new WeakMap(), h = new WeakMap(), y = new WeakMap(), m = new WeakMap(), w = new WeakMap(), g = new WeakMap(), j = new WeakMap(), k = new WeakMap(), o = function () {
      function t(n, o, O, S, E, T, P, I) {
        var W,
          F = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: void 0
        }), u.set(this, {
          writable: !0,
          value: void 0
        }), c.set(this, {
          writable: !0,
          value: void 0
        }), s.set(this, {
          writable: !0,
          value: void 0
        }), l.set(this, {
          writable: !0,
          value: void 0
        }), f.set(this, {
          writable: !0,
          value: void 0
        }), d.set(this, {
          writable: !0,
          value: void 0
        }), p.set(this, {
          writable: !0,
          value: function value(e, t) {
            F.getRawTwilsockClient().on(e, function () {
              for (var e, n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
              return (e = U(F, l)).emit.apply(e, [t].concat(r));
            });
          }
        }), v.set(this, {
          writable: !0,
          value: function value() {
            U(F, p).call(F, C.a.TokenExpired, R.a.TokenExpired), U(F, p).call(F, C.a.TokenAboutToExpire, R.a.TokenAboutToExpire), U(F, p).call(F, C.a.StateChanged, R.a.StateChanged), U(F, p).call(F, C.a.Connected, R.a.Connected), U(F, p).call(F, C.a.Disconnected, R.a.Disconnected), U(F, h).call(F);
          }
        }), b.set(this, {
          writable: !0,
          value: function value() {
            var e = x.a.getLogger("twilsock");
            e.methodFactory = function (e) {
              return function () {
                var t;
                return (t = U(F, u))[e].apply(t, arguments);
              };
            }, e.setLevel("trace");
          }
        }), h.set(this, {
          writable: !0,
          value: function value() {
            F.getRawTwilsockClient().on(C.a.ConnectionError, function (e) {
              var t = e.errorCode,
                n = e.metadata,
                r = e.message,
                o = new M.c(t || M.a.TwilsockConnectionError, n, r);
              U(F, l).emit(R.a.ConnectionError, o);
            });
          }
        }), y.set(this, {
          writable: !0,
          value: function value(e) {
            return e instanceof M.c && e.code === M.a.TwilsockConnectionError;
          }
        }), m.set(this, {
          writable: !0,
          value: function value(e) {
            return Object(q.b)(e) && 429 === e.reply.status.code;
          }
        }), w.set(this, {
          writable: !0,
          value: function value(e) {
            return Object(q.b)(e) && e.reply.status.code >= 500;
          }
        }), g.set(this, {
          writable: !0,
          value: function value(e) {
            return U(F, m).call(F, e) || U(F, w).call(F, e) || U(F, y).call(F, e);
          }
        }), j.set(this, {
          writable: !0,
          value: (W = N(_regeneratorRuntime().mark(function t(n) {
            var o;
            return _regeneratorRuntime().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  if (F.twilsockClient) {
                    t.next = 5;
                    break;
                  }
                  o = {
                    module: Object(D.b)(e),
                    severity: M.b.Error,
                    source: Object(D.a)(r)
                  }, U(F, f).call(F, M.a.InvalidState, o, "no twilsock client"), t.next = 8;
                  break;
                case 5:
                  return t.next = 7, F.twilsockClient.updateToken(n);
                case 7:
                  U(F, l).emit(R.a.TokenUpdated, n);
                case 8:
                case "end":
                  return t.stop();
              }
            }, t);
          })), function (e) {
            return W.apply(this, arguments);
          })
        }), k.set(this, {
          writable: !0,
          value: function value() {
            return new Promise(function (e, t) {
              if (F.getRawTwilsockClient().isConnected) e();else {
                var n = function n() {
                    return e();
                  },
                  r = function r(e) {
                    return t(e);
                  },
                  o = function o() {
                    F.removeListener(R.a.Connected, n), F.removeListener(R.a.ConnectionError, r);
                  };
                F.addListener(R.a.Connected, function () {
                  o(), n();
                }), F.addListener(R.a.ConnectionError, function (e) {
                  o(), r(e);
                });
              }
            });
          }
        }), V(this, a, n), V(this, i, o), V(this, u, O(A.b.Twilsock)), U(this, u).debug("Twilsock constructed"), V(this, c, S), V(this, s, E), V(this, l, T), V(this, f, P), V(this, d, I);
      }
      var n, o, S, L, K, z, B;
      return t = Object(O.inject)(M.e)(t, void 0, 7) || t, t = Object(O.inject)(M.g)(t, void 0, 6) || t, t = Object(O.inject)(T.b)(t, void 0, 5) || t, t = Object(O.inject)(W.b)(t, void 0, 4) || t, t = Object(O.inject)(I.e)(t, void 0, 3) || t, t = Object(O.inject)(A.d)(t, void 0, 2) || t, t = Object(O.inject)(P.b)(t, void 0, 1) || t, t = Object(O.inject)(P.c)(t, void 0, 0) || t, n = t, (o = [{
        key: "connect",
        value: (B = N(_regeneratorRuntime().mark(function e(t) {
          var n;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (!this.twilsockClient) {
                  e.next = 2;
                  break;
                }
                throw new M.d("Twilsock connection already exists");
              case 2:
                return n = {
                  region: U(this, s).region || U(this, c).region,
                  clientMetadata: {
                    type: "flex-sdk",
                    sdk: "JS",
                    sdkv: E.a,
                    app: U(this, s).appName,
                    appv: U(this, s).appVersion
                  }
                }, this.twilsockClient = U(this, a).call(this, t, U(this, i), n), U(this, v).call(this), U(this, b).call(this), this.twilsockClient.connect(), e.next = 9, U(this, k).call(this);
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return B.apply(this, arguments);
        })
      }, {
        key: "updateToken",
        value: (z = N(_regeneratorRuntime().mark(function t(n) {
          var r,
            o = this;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, Object(F.a)({
                  functionToRetry: function functionToRetry() {
                    return U(o, j).call(o, n);
                  },
                  retryCondition: U(this, g),
                  logger: U(this, u)
                });
              case 3:
                t.next = 9;
                break;
              case 5:
                t.prev = 5, t.t0 = t.catch(0), r = {
                  module: Object(D.b)(e),
                  severity: M.b.Error,
                  source: "update Twilsock token"
                }, U(this, d).call(this, t.t0, r);
              case 9:
              case "end":
                return t.stop();
            }
          }, t, this, [[0, 5]]);
        })), function (e) {
          return z.apply(this, arguments);
        })
      }, {
        key: "getRawTwilsockClient",
        value: function value() {
          if (!this.twilsockClient) throw new M.d("Twilsock hasn't been initialized");
          return this.twilsockClient;
        }
      }, {
        key: "post",
        value: (K = N(_regeneratorRuntime().mark(function t(n, o, i) {
          var a,
            c,
            s,
            l,
            d,
            p = this;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, Object(F.a)({
                  functionToRetry: function functionToRetry() {
                    return p.getRawTwilsockClient().post(n, o, i);
                  },
                  retryCondition: U(this, g),
                  logger: U(this, u)
                });
              case 3:
                return t.abrupt("return", t.sent);
              case 6:
                return t.prev = 6, t.t0 = t.catch(0), s = (null === (a = t.t0.body) || void 0 === a ? void 0 : a.code) || M.a.SDK, l = (null === (c = t.t0.body) || void 0 === c ? void 0 : c.message) || t.t0.message, d = {
                  module: Object(D.b)(e),
                  severity: M.b.Error,
                  source: Object(D.a)(r)
                }, t.abrupt("return", U(this, f).call(this, s, d, l, t.t0));
              case 12:
              case "end":
                return t.stop();
            }
          }, t, this, [[0, 6]]);
        })), function (e, t, n) {
          return K.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: (L = N(_regeneratorRuntime().mark(function e() {
          var t, n;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (this.twilsockClient) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return t = this.twilsockClient, n = new Promise(function (e) {
                  t.on(C.a.Disconnected, e);
                }), e.next = 6, t.disconnect();
              case 6:
                return e.next = 8, n;
              case 8:
                delete this.twilsockClient, U(this, l).removeAllListeners();
              case 10:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function () {
          return L.apply(this, arguments);
        })
      }, {
        key: "addListener",
        value: function value(e, t) {
          return U(this, l).on(e, t), this;
        }
      }, {
        key: "removeListener",
        value: function value(e, t) {
          return U(this, l).removeListener(e, t), this;
        }
      }, {
        key: "isConnected",
        value: function value() {
          return !!this.twilsockClient && this.getRawTwilsockClient().isConnected;
        }
      }]) && _(n.prototype, o), S && _(n, S), t;
    }())) || o;
  }).call(this, "src/modules/websocket/Twilsock", "src/modules/websocket/Twilsock/TwilsockImpl.ts");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return u;
    });
    n(53), n(54), n(3), n(57), n(27);
    var o = n(18),
      i = n(1),
      a = n(2),
      u = function u(t) {
        return function (n) {
          return function (u, c, s) {
            var l = s.value,
              f = t.get(o.c);
            s.value = function () {
              var o = f.roles;
              if (!o.includes(n)) {
                var u = o.length ? o.toString() : "no role",
                  c = {
                    module: Object(a.b)(e),
                    severity: i.b.Error,
                    source: Object(a.a)(r)
                  },
                  s = t.get(i.g);
                s(i.a.Forbidden, c, "Expected the role ".concat(n, ", but got ").concat(u, " instead."));
              }
              for (var d = arguments.length, p = new Array(d), v = 0; v < d; v++) p[v] = arguments[v];
              var b = l.apply(this, p);
              return b;
            };
          };
        };
      };
  }).call(this, "src/modules/rbac/RequiredRole", "src/modules/rbac/RequiredRole/requiredRole.ts");
}, function (e, t, n) {
  var r, o;
  function i(e) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  n(55), n(63), n(38), n(9), n(14), n(3), n(36), n(5), n(6), n(7), function (a, u) {
    "use strict";

    void 0 === (o = "function" == typeof (r = function r() {
      var e = function e() {},
        t = "undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) && "undefined" !== i(window.navigator) && /Trident\/|MSIE /.test(window.navigator.userAgent),
        n = ["trace", "debug", "info", "warn", "error"];
      function r(e, t) {
        var n = e[t];
        if ("function" == typeof n.bind) return n.bind(e);
        try {
          return Function.prototype.bind.call(n, e);
        } catch (t) {
          return function () {
            return Function.prototype.apply.apply(n, [e, arguments]);
          };
        }
      }
      function o() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function a(n) {
        return "debug" === n && (n = "log"), "undefined" !== ("undefined" == typeof console ? "undefined" : i(console)) && ("trace" === n && t ? o : void 0 !== console[n] ? r(console, n) : void 0 !== console.log ? r(console, "log") : e);
      }
      function u(t, r) {
        for (var o = 0; o < n.length; o++) {
          var i = n[o];
          this[i] = o < t ? e : this.methodFactory(i, t, r);
        }
        this.log = this.debug;
      }
      function c(e, t, n) {
        return function () {
          "undefined" !== ("undefined" == typeof console ? "undefined" : i(console)) && (u.call(this, t, n), this[e].apply(this, arguments));
        };
      }
      function s(e, t, n) {
        return a(e) || c.apply(this, arguments);
      }
      function l(e, t, r) {
        var o,
          a = this,
          c = "loglevel";
        function l() {
          var e;
          if ("undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) && c) {
            try {
              e = window.localStorage[c];
            } catch (e) {}
            if ("undefined" === i(e)) try {
              var t = window.document.cookie,
                n = t.indexOf(encodeURIComponent(c) + "=");
              -1 !== n && (e = /^([^;]+)/.exec(t.slice(n))[1]);
            } catch (e) {}
            return void 0 === a.levels[e] && (e = void 0), e;
          }
        }
        "string" == typeof e ? c += ":" + e : "symbol" === i(e) && (c = void 0), a.name = e, a.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, a.methodFactory = r || s, a.getLevel = function () {
          return o;
        }, a.setLevel = function (t, r) {
          if ("string" == typeof t && void 0 !== a.levels[t.toUpperCase()] && (t = a.levels[t.toUpperCase()]), !("number" == typeof t && t >= 0 && t <= a.levels.SILENT)) throw "log.setLevel() called with invalid level: " + t;
          if (o = t, !1 !== r && function (e) {
            var t = (n[e] || "silent").toUpperCase();
            if ("undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) && c) {
              try {
                return void (window.localStorage[c] = t);
              } catch (e) {}
              try {
                window.document.cookie = encodeURIComponent(c) + "=" + t + ";";
              } catch (e) {}
            }
          }(t), u.call(a, t, e), "undefined" === ("undefined" == typeof console ? "undefined" : i(console)) && t < a.levels.SILENT) return "No console available for logging";
        }, a.setDefaultLevel = function (e) {
          l() || a.setLevel(e, !1);
        }, a.enableAll = function (e) {
          a.setLevel(a.levels.TRACE, e);
        }, a.disableAll = function (e) {
          a.setLevel(a.levels.SILENT, e);
        };
        var f = l();
        null == f && (f = null == t ? "WARN" : t), a.setLevel(f, !1);
      }
      var f = new l(),
        d = {};
      f.getLogger = function (e) {
        if ("symbol" !== i(e) && "string" != typeof e || "" === e) throw new TypeError("You must supply a name when creating a logger.");
        var t = d[e];
        return t || (t = d[e] = new l(e, f.getLevel(), f.methodFactory)), t;
      };
      var p = "undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) ? window.log : void 0;
      return f.noConflict = function () {
        return "undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) && window.log === f && (window.log = p), f;
      }, f.getLoggers = function () {
        return d;
      }, f.default = f, f;
    }) ? r.call(t, n, t, e) : r) || (e.exports = o);
  }();
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return W;
    });
    n(31), n(9), n(43), n(35), n(44), n(14), n(36), n(74), n(38), n(17), n(5), n(3), n(6), n(13), n(7), n(53), n(54), n(26), n(27), n(63), n(11), n(72);
    var o,
      i,
      a,
      u,
      c,
      s,
      l,
      f,
      d,
      p,
      v = n(0),
      b = n(4),
      h = n(111),
      y = n(16),
      m = n(1),
      w = n(25),
      g = n(2),
      j = n(70),
      k = n(12);
    function O(e) {
      return function (e) {
        if (Array.isArray(e)) return S(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return S(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return S(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function S(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function x(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function E(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? x(Object(n), !0).forEach(function (t) {
          T(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function T(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function C(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function P(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);
          function a(e) {
            C(i, r, o, a, u, "next", e);
          }
          function u(e) {
            C(i, r, o, a, u, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function R(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function M(e, t) {
      return function (e, t) {
        if (t.get) return t.get.call(e);
        return t.value;
      }(e, I(e, t, "get"));
    }
    function A(e, t, n) {
      return function (e, t, n) {
        if (t.set) t.set.call(e, n);else {
          if (!t.writable) throw new TypeError("attempted to set read only private field");
          t.value = n;
        }
      }(e, I(e, t, "set"), n), n;
    }
    function I(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
      return t.get(e);
    }
    var W = Object(v.injectable)()((i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), l = new WeakMap(), f = new WeakMap(), d = new WeakMap(), p = new WeakMap(), o = function () {
      function t(n, o, v, h, y, w) {
        var j,
          k = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: void 0
        }), u.set(this, {
          writable: !0,
          value: !1
        }), c.set(this, {
          writable: !0,
          value: void 0
        }), s.set(this, {
          writable: !0,
          value: void 0
        }), l.set(this, {
          writable: !0,
          value: void 0
        }), f.set(this, {
          writable: !0,
          value: void 0
        }), d.set(this, {
          writable: !0,
          value: (j = P(_regeneratorRuntime().mark(function t(n) {
            var o,
              s,
              l,
              f,
              d,
              v,
              b,
              h,
              y = arguments;
            return _regeneratorRuntime().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  for (o = y.length, s = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++) s[l - 1] = y[l];
                  return M(k, i).debug("Sending", s.length, "telemetry events"), M(k, i).trace("Events", s), f = {
                    number_of_successful_events: 0,
                    number_of_failed_events: 0
                  }, t.prev = 4, M(k, p).call(k, n).check(), t.next = 9, M(k, a).postTelemetryEvents({
                    events: s
                  });
                case 9:
                  d = t.sent, (v = d.body) && (f = v, M(k, i).debug("Telemetry sent successfully")), t.next = 22;
                  break;
                case 14:
                  if (t.prev = 14, t.t0 = t.catch(4), !(t.t0 instanceof m.c && [m.a.TooManySDKRequests, m.a.TemporarilyDisabled].includes(t.t0.code))) {
                    t.next = 18;
                    break;
                  }
                  return t.abrupt("return", f);
                case 18:
                  409 !== (null === (b = t.t0.wrappedError) || void 0 === b ? void 0 : b.status) && (h = {
                    module: Object(g.b)(e),
                    severity: m.b.Error,
                    eventSource: Object(g.a)(r)
                  }, M(k, c).call(k, t.t0, h)), M(k, i).warn("Telemetry is disabled for this account"), A(k, u, !0);
                case 22:
                  return t.abrupt("return", f);
                case 23:
                case "end":
                  return t.stop();
              }
            }, t, null, [[4, 14]]);
          })), function (e) {
            return j.apply(this, arguments);
          })
        }), p.set(this, {
          writable: !0,
          value: function value(e) {
            return M(k, l).call(k, E(E({}, M(k, f)), {}, {
              name: e
            }));
          }
        }), A(this, i, n(b.c.TelemetryProcessor)), A(this, a, o), A(this, s, v), A(this, c, h), A(this, l, y), A(this, f, w);
      }
      var n, o, S, x;
      return t = Object(v.inject)(k.g)(t, void 0, 5) || t, t = Object(v.inject)(j.b)(t, void 0, 4) || t, t = Object(v.inject)(m.e)(t, void 0, 3) || t, t = Object(v.inject)(m.g)(t, void 0, 2) || t, t = Object(v.inject)(y.e)(t, void 0, 1) || t, t = Object(v.inject)(b.d)(t, void 0, 0) || t, n = t, (o = [{
        key: "processEvents",
        value: (x = P(_regeneratorRuntime().mark(function e(t, n, r) {
          var o,
            a,
            c,
            l,
            f,
            p,
            v,
            b,
            y,
            m,
            g,
            j,
            k = arguments;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                for (Object(w.c)(t, "payload type"), void 0 !== n && Object(w.c)(n, "group name"), o = k.length, a = new Array(o > 3 ? o - 3 : 0), c = 3; c < o; c++) a[c - 3] = k[c];
                if (a.forEach(function (e) {
                  var t = e.eventName,
                    n = e.eventSource;
                  Object(w.c)(t, "event name"), void 0 !== n && Object(w.c)(n, "event source");
                }), !M(this, u)) {
                  e.next = 7;
                  break;
                }
                return M(this, i).trace("Events not sent: telemetry disabled"), e.abrupt("return", {
                  eventsNotProcessed: a.length,
                  eventsSucceeded: 0,
                  eventsFailed: 0
                });
              case 7:
                if (M(this, i).debug("common attributes:", r), l = h.a.apply(void 0, [M(this, s), t, n, r].concat(a)), f = 0, p = 0, !l.length) {
                  e.next = 19;
                  break;
                }
                for (b = [], y = 0; y < l.length; y += 50) v = l.slice(y, y + 50), b.push((m = M(this, d)).call.apply(m, [this, t].concat(O(v))));
                return e.next = 16, Promise.all(b);
              case 16:
                g = e.sent, f = g.reduce(function (e, t) {
                  return e + t.number_of_successful_events;
                }, 0), p = g.reduce(function (e, t) {
                  return e + t.number_of_failed_events;
                }, 0);
              case 19:
                return j = a.length - f - p, e.abrupt("return", {
                  eventsSucceeded: f,
                  eventsFailed: p,
                  eventsNotProcessed: j
                });
              case 21:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e, t, n) {
          return x.apply(this, arguments);
        })
      }]) && R(n.prototype, o), S && R(n, S), t;
    }())) || o;
  }).call(this, "src/modules/telemetry/TelemetryProcessor/TwilioEventProcessor", "src/modules/telemetry/TelemetryProcessor/TwilioEventProcessor/TwilioTelemetryProcessor.ts");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return f;
    });
    n(98), n(31), n(9), n(43), n(35), n(26), n(44);
    var o = n(48),
      i = n(1),
      a = n(2);
    function u(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function c(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? u(Object(n), !0).forEach(function (t) {
          s(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function s(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function l(t, n, u, s, l) {
      var f,
        d = void 0 === l ? {} : Object(o.a)(l),
        p = c(c({}, Object(o.a)(u)), {}, {
          client_timestamp: new Date().toISOString(),
          event_group: s
        });
      if (f = p, Object.prototype.hasOwnProperty.call(f, "event_name") && Object.prototype.hasOwnProperty.call(f, "client_timestamp")) return {
        payload_type: n,
        payload: c(c({}, p), d)
      };
      var v = {
        module: Object(a.b)(e),
        severity: i.b.Error,
        source: Object(a.a)(r)
      };
      return t(i.a.InvalidParams, v, "Telemetry event has missing fields");
    }
    function f(e, t, n, r) {
      for (var o = arguments.length, i = new Array(o > 4 ? o - 4 : 0), a = 4; a < o; a++) i[a - 4] = arguments[a];
      return i.map(function (o) {
        return l(e, t, o, n, r);
      });
    }
  }).call(this, "src/modules/telemetry/TelemetryProcessor/TwilioEventProcessor", "src/modules/telemetry/TelemetryProcessor/TwilioEventProcessor/toSdkBackendEvent.ts");
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return p;
    });
    n(17), n(5), n(3), n(6), n(13), n(7), n(11);
    var r,
      o,
      i = n(0),
      a = n(1),
      u = n(16),
      c = n(2);
    function s(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function l(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function f(e, t, n) {
      return function (e, t, n) {
        if (t.set) t.set.call(e, n);else {
          if (!t.writable) throw new TypeError("attempted to set read only private field");
          t.value = n;
        }
      }(e, d(e, t, "set"), n), n;
    }
    function d(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
      return t.get(e);
    }
    var p = Object(i.injectable)()((o = new WeakMap(), r = function () {
      function t(e, n) {
        var r, i, a;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), a = "http://flex-sdk.twilio.com/v1", (i = "basePath") in (r = this) ? Object.defineProperty(r, i, {
          value: a,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : r[i] = a, o.set(this, {
          writable: !0,
          value: void 0
        }), this.twilsockAdapter = e, f(this, o, n);
      }
      var n, r, p, v, b;
      return t = Object(i.inject)(a.g)(t, void 0, 1) || t, t = Object(i.inject)(u.f)(t, void 0, 0) || t, n = t, (r = [{
        key: "postTelemetryEvents",
        value: (v = _regeneratorRuntime().mark(function t(n) {
          var r, i;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return null == n && (r = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(c.a)(e)
                }, (u = this, s = o, function (e, t) {
                  return t.get ? t.get.call(e) : t.value;
                }(u, d(u, s, "get"))).call(this, a.a.InvalidParams, r, "Required parameter events was null or undefined when calling postTelemetryEvents.")), t.next = 3, this.twilsockAdapter.post("".concat(this.basePath, "/Telemetry/Events"), n);
              case 3:
                return i = t.sent, t.abrupt("return", i);
              case 5:
              case "end":
                return t.stop();
            }
            var u, s;
          }, t, this);
        }), b = function b() {
          var e = this,
            t = arguments;
          return new Promise(function (n, r) {
            var o = v.apply(e, t);
            function i(e) {
              s(o, n, r, i, a, "next", e);
            }
            function a(e) {
              s(o, n, r, i, a, "throw", e);
            }
            i(void 0);
          });
        }, function (e) {
          return b.apply(this, arguments);
        })
      }]) && l(n.prototype, r), p && l(n, p), t;
    }())) || r;
  }).call(this, "src/backend/generated/Telemetry/api/telemetry.service.ts");
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return y;
    });
    n(11), n(17), n(5), n(3), n(6), n(13), n(7), n(27);
    var r,
      o,
      i = n(0),
      a = n(1),
      u = n(16),
      c = n(45),
      s = n(41),
      l = n(2);
    function f(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function d(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);
          function a(e) {
            f(i, r, o, a, u, "next", e);
          }
          function u(e) {
            f(i, r, o, a, u, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function p(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function v(e, t) {
      return function (e, t) {
        if (t.get) return t.get.call(e);
        return t.value;
      }(e, h(e, t, "get"));
    }
    function b(e, t, n) {
      return function (e, t, n) {
        if (t.set) t.set.call(e, n);else {
          if (!t.writable) throw new TypeError("attempted to set read only private field");
          t.value = n;
        }
      }(e, h(e, t, "set"), n), n;
    }
    function h(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
      return t.get(e);
    }
    var y = Object(i.injectable)()((o = new WeakMap(), r = function () {
      function t(e, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o.set(this, {
          writable: !0,
          value: void 0
        }), this.httpAdapter = e, b(this, o, n);
      }
      var n, r, f, h, y, m;
      return t = Object(i.inject)(a.g)(t, void 0, 1) || t, t = Object(i.inject)(u.d)(t, void 0, 0) || t, n = t, (r = [{
        key: "fetchConfiguration",
        value: (m = d(_regeneratorRuntime().mark(function e(t, n, r) {
          var o, i;
          return _regeneratorRuntime().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.httpAdapter.get("https://flex-api[environment].twilio.com/v1/Configuration?".concat(encodeURIComponent(String(t)), "=").concat(encodeURIComponent(String(n))), c.a.Basic, r);
              case 2:
                return o = e.sent, i = Object(s.a)(o), e.abrupt("return", i);
              case 5:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e, t, n) {
          return m.apply(this, arguments);
        })
      }, {
        key: "fetchPublicConfiguration",
        value: (y = d(_regeneratorRuntime().mark(function t(n, r) {
          var i, u, c, f;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return null == n && (i = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, i, "Required parameter queryParamName was null or undefined.")), null == r && (u = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, u, "Required parameter queryParamValue was null or undefined.")), t.next = 4, this.httpAdapter.get("https://flex-api[environment].twilio.com/v1/Configuration/Public?".concat(encodeURIComponent(String(n)), "=").concat(encodeURIComponent(String(r))), void 0);
              case 4:
                return c = t.sent, f = Object(s.a)(c), t.abrupt("return", f);
              case 7:
              case "end":
                return t.stop();
            }
          }, t, this);
        })), function (e, t) {
          return y.apply(this, arguments);
        })
      }, {
        key: "updateConfiguration",
        value: (h = d(_regeneratorRuntime().mark(function t(n) {
          var r, i, u;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return null == n && (r = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, r, "Required parameter accountConfigData was null or undefined.")), t.next = 3, this.httpAdapter.post("https://flex-api[environment].twilio.com/v1/Configuration", c.a.Basic, n);
              case 3:
                return i = t.sent, u = Object(s.a)(i), t.abrupt("return", u);
              case 6:
              case "end":
                return t.stop();
            }
          }, t, this);
        })), function (e) {
          return h.apply(this, arguments);
        })
      }]) && p(n.prototype, r), f && p(n, f), t;
    }())) || r;
  }).call(this, "src/backend/generated/Configuration/api/configuration.service.ts");
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return y;
    });
    n(17), n(5), n(3), n(6), n(13), n(7), n(11);
    var r,
      o,
      i = n(0),
      a = n(1),
      u = n(16),
      c = n(45),
      s = n(41),
      l = n(2);
    function f(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
          c = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }
    function d(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);
          function a(e) {
            f(i, r, o, a, u, "next", e);
          }
          function u(e) {
            f(i, r, o, a, u, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function p(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function v(e, t) {
      return function (e, t) {
        if (t.get) return t.get.call(e);
        return t.value;
      }(e, h(e, t, "get"));
    }
    function b(e, t, n) {
      return function (e, t, n) {
        if (t.set) t.set.call(e, n);else {
          if (!t.writable) throw new TypeError("attempted to set read only private field");
          t.value = n;
        }
      }(e, h(e, t, "set"), n), n;
    }
    function h(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
      return t.get(e);
    }
    var y = Object(i.injectable)()((o = new WeakMap(), r = function () {
      function t(e, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o.set(this, {
          writable: !0,
          value: void 0
        }), this.httpAdapter = e, b(this, o, n);
      }
      var n, r, f, h, y, m;
      return t = Object(i.inject)(a.g)(t, void 0, 1) || t, t = Object(i.inject)(u.d)(t, void 0, 0) || t, n = t, (r = [{
        key: "getIdpUrl",
        value: (m = d(_regeneratorRuntime().mark(function t(n, r) {
          var i, u, c, f;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return null == n && (i = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, i, "Required parameter accountSid was null or undefined.")), null == r && (u = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, u, "Required parameter sSOLoginRequestBody was null or undefined.")), t.next = 4, this.httpAdapter.post("https://iam[environment].twilio.com/v1/Accounts/".concat(encodeURIComponent(String(n)), "/authenticate"), void 0, r);
              case 4:
                return c = t.sent, f = Object(s.a)(c), t.abrupt("return", f);
              case 7:
              case "end":
                return t.stop();
            }
          }, t, this);
        })), function (e, t) {
          return m.apply(this, arguments);
        })
      }, {
        key: "refreshToken",
        value: (y = d(_regeneratorRuntime().mark(function t(n, r) {
          var i, u, c, f;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return null == n && (i = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, i, "Required parameter accountSid was null or undefined.")), null == r && (u = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, u, "Required parameter token was null or undefined.")), t.next = 4, this.httpAdapter.post("https://iam[environment].twilio.com/v1/Accounts/".concat(encodeURIComponent(String(n)), "/Tokens/refresh"), void 0, r);
              case 4:
                return c = t.sent, f = Object(s.a)(c), t.abrupt("return", f);
              case 7:
              case "end":
                return t.stop();
            }
          }, t, this);
        })), function (e, t) {
          return y.apply(this, arguments);
        })
      }, {
        key: "validateToken",
        value: (h = d(_regeneratorRuntime().mark(function t(n, r, i) {
          var u, f, d, p;
          return _regeneratorRuntime().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return null == n && (u = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, u, "Required parameter accountSid was null or undefined.")), null == r && (f = {
                  module: "backend",
                  severity: a.b.Error,
                  source: Object(l.a)(e)
                }, v(this, o).call(this, a.a.InvalidParams, f, "Required parameter token was null or undefined.")), t.next = 4, this.httpAdapter.post("https://iam[environment].twilio.com/v1/Accounts/".concat(encodeURIComponent(String(n)), "/Tokens/validate"), c.a.Basic, r, i);
              case 4:
                return d = t.sent, p = Object(s.a)(d), t.abrupt("return", p);
              case 7:
              case "end":
                return t.stop();
            }
          }, t, this);
        })), function (e, t, n) {
          return h.apply(this, arguments);
        })
      }]) && p(n.prototype, r), f && p(n, f), t;
    }())) || r;
  }).call(this, "src/backend/generated/FederatedAuth/api/federatedAuth.service.ts");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return o;
  });
  n(53), n(54);
  var r = n(1),
    o = function o(e) {
      return [r.a.Unknown, r.a.TooManyRequests, r.a.NetworkError].includes(e.code);
    };
}, function (e, t) {
  e.exports = require("reflect-metadata");
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "LoggerName", function () {
    return c.b;
  }), n.d(t, "ClientEvent", function () {
    return a.a;
  }), n.d(t, "auth", function () {
    return d;
  }), n.d(t, "getLogger", function () {
    return p;
  }), n.d(t, "getTwilioIdpUrl", function () {
    return v;
  }), n.d(t, "getPublicConfig", function () {
    return b;
  }), n.d(t, "getAccountConfig", function () {
    return h;
  }), n.d(t, "createClient", function () {
    return y;
  }), n.d(t, "clearCache", function () {
    return m;
  }), n.d(t, "version", function () {
    return w;
  }), n.d(t, "FlexSdkError", function () {
    return f.c;
  }), n.d(t, "ErrorCode", function () {
    return f.a;
  }), n.d(t, "ErrorSeverity", function () {
    return f.b;
  });
  var r = n(68),
    o = n(46),
    i = n(8),
    a = n(15),
    u = n(34),
    c = n(4);
  function s(e) {
    return function (t) {
      return function () {
        var n = e(),
          r = n.get(t);
        return r.apply(void 0, arguments);
      };
    };
  }
  var l = n(42),
    f = n(1),
    d = s(o.a)(u.b),
    p = s(o.b)(c.d),
    v = s(o.a)(u.d),
    b = s(o.a)(i.h),
    h = s(o.a)(i.g),
    y = s(o.a)(a.c),
    m = s(o.a)(l.a),
    w = r.a;
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.find.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.number.is-nan.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.ends-with.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.regexp.constructor.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.entries.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.starts-with.js");
}]);